<!-- VizletHeader.vue -->
<template>
  <div class="d-flex justify-content-between p-1">
    <div
      class="mr-auto d-flex align-items-center sc-vh-title-row"
      v-if="vizCount !== 1"
    >
      <span class="sc-vh-title-row__info">
        <i
          style="margin-right: 6px"
          :class="
            viz1.vizlet_title_info
              ? 'fa fa-info-circle custom-icon'
              : 'fa fa-info-circle'
          "
          :style="{ color: viz1.vizlet_title_info ? '#5e8ef4' : 'inherit' }"
          ref="tooltipIcon"
          v-b-tooltip.hover.right.html="
            configEditMode && $store.state.deviceType !== 'Mobile'
              ? false
              : {
                  title: viz1.vizlet_title_info,
                  customClass: 'my-custom-tooltip1',
                  autoHide: false,
                }
          "
          @mouseenter="showTooltip"
          @mouseleave="hideTooltip"
        />
        <inline-title-field
          v-if="configEditMode && $store.state.deviceType !== 'Mobile'"
          pen-only
          rich-text
          :value="viz1.vizlet_title_info || ''"
          :edit-mode="configEditMode"
          field-label="Vizlet info"
          @save="emitVizletTitleSave('vizlet_title_info', $event)"
        />
      </span>
      <template v-if="$store.state.deviceType !== 'Mobile'">
        <inline-title-field
          v-if="configEditMode"
          :value="viz1.vizletTitleDpName || ''"
          :edit-mode="configEditMode"
          field-label="Vizlet title"
          placeholder="Vizlet title"
          @save="emitVizletTitleSave('vizlet_title', $event)"
        />
        <span v-else>{{ viz1.vizletTitleDpName }}</span>
        <inline-title-field
          v-if="configEditMode"
          muted
          :value="viz1.vizletTitleDpShortName || ''"
          :edit-mode="configEditMode"
          field-label="Short title"
          placeholder="Short"
          @save="emitVizletTitleSave('vizlet_title_short', $event)"
        />
      </template>
      <i
        v-if="
          viz1.insight_navigator && viz1.insight_navigator.navList.length > 0
        "
        class="fas fa-book-reader"
        style="margin-left: 10px;color: #6495ED;"
      ></i>
    </div>

    <div
      v-show="viz1.vizletMiddleTitleFlag"
      class="mr-auto p-2"
      style="font-size: 30px;font-weight: bold"
      v-if="vizCount !== 1"
    >
      <span v-show="format(total)"
        >{{ viz1.vizletTitleMiddleName }} : {{ format(total) }}</span
      >
    </div>
    <span
        class="gemini-icon-btn"
        title="AI Insights"
        @click="openAiChat"
    >
        <svg class="gemini-svg" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 0C14 7.732 7.732 14 0 14c7.732 0 14 6.268 14 14 0-7.732 6.268-14 14-14-7.732 0-14-6.268-14-14z" fill="currentColor"/>
        </svg>
      </span>
    <div
      v-if="viz1.viztypeName === 'TableBar' || viz1.viztypeName === 'Tabulator'"
      class="d-flex align-items-center"
      style="margin-top: -2px;margin-right: 10px"
    >
      <input
        type="text"
        placeholder="Search..."
        v-model="localSearchQuery"
        @input="handleSearchInput"
        class="form-control form-control-sm"
      />
      <span
        v-if="viz1.viztypeName === 'TableBar'"
        title="Manage Columns"
        @click="openColumnManager"
        style="cursor:pointer;margin-left:6px;font-size:14px;color:#555"
      >
        <i class="fas fa-columns"></i>
      </span>
    </div>

    <!-- Column Manager: left drawer, draggable header, no backdrop -->
    <b-modal
      ref="col-manager-modal"
      hide-footer
      hide-backdrop
      no-close-on-backdrop
      no-fade
      :modal-class="['vizlet-header-col-manager-drawer', drawerInstanceId]"
      dialog-class="vizlet-header-side-dialog vizlet-header-col-manager-dialog"
      content-class="vizlet-header-drawer-content"
      @shown="onColumnManagerDrawerShown"
      @hidden="onColumnManagerDrawerHidden"
    >
      <template #modal-header="{ close }">
        <div class="d-flex align-items-center w-100 vizlet-drawer-header-row">
          <div
            class="flex-grow-1 d-flex align-items-center vizlet-drawer-drag-handle py-1 pr-1"
            title="Drag to move. Double-click to snap back to the left edge."
            @mousedown.stop="onColManagerHeaderPointerDown"
            @touchstart.stop.prevent="onColManagerHeaderTouchStart"
            @dblclick.stop="resetDrawerPosition('col-manager')"
          >
            <h5 class="mb-0 vizlet-drawer-title">Manage columns</h5>
            <i class="fas fa-grip-vertical ml-2 text-muted vizlet-drawer-grip" aria-hidden="true" />
          </div>
          <b-button-close
            class="vizlet-drawer-close"
            @mousedown.stop
            @click="close"
          />
        </div>
      </template>
      <b-alert
        v-if="columnManagerFetchError"
        show
        variant="warning"
        class="mb-3 vizlet-drawer-alert fw-copyable-text"
        tabindex="0"
        @keydown="onCopyableRegionKeydown"
      >
        <div>{{ columnManagerFetchError }}</div>
        <template v-if="columnManagerFetchErrorQuery">
          <div class="small text-muted mt-2 mb-1">Query that caused the error:</div>
          <pre class="vizlet-fetch-error-query mb-0">{{ columnManagerFetchErrorQuery }}</pre>
        </template>
      </b-alert>
      <div class="vizlet-col-manager-layout">
      <p class="text-muted vizlet-col-manager-hint mb-2">
        Drag names to reorder them.
        <b-button
          variant="link"
          size="sm"
          class="p-0 align-baseline"
          @click="openRatioModal"
        >
          Create custom column
        </b-button>
      </p>

      <div class="col-manager-chips">
        <draggable
          v-model="visibleColumns"
          :disabled="!!editingColumnChipKey"
          @start="onDragStart"
          @end="onDragEnd"
          class="col-manager-chip-grid"
          ghost-class="chip-ghost"
        >
          <div
            v-for="(col, idx) in visibleColumns"
            :key="columnChipKey(col, idx)"
            class="col-chip"
          >
            <input
              v-if="isInlineBaseInputEditable(col)"
              v-model="col.base"
              class="chip-base-input chip-label"
              :class="{ 'chip-base-input--editing': isEditingColumnChip(col, idx) }"
              type="text"
              :ref="columnChipInputRefName(col, idx)"
              :title="visibleColumnInputTooltip(col)"
              :readonly="!isEditingColumnChip(col, idx)"
              @click.stop
              @blur="stopColumnChipInlineEdit"
              @keyup.enter="stopColumnChipInlineEdit"
              @keyup.esc="stopColumnChipInlineEdit"
            />
            <i
              v-if="isInlineBaseEditSupported(col)"
              class="fas fa-edit chip-inline-edit"
              :title="isEditingColumnChip(col, idx) ? 'Finish editing name' : 'Edit column name'"
              aria-label="Edit column name"
              @click.stop="toggleColumnChipInlineEdit(col, idx)"
            />
            <span v-if="!isInlineBaseInputEditable(col)" class="chip-label">{{ visibleColumnChipLabel(col) }}</span>
            <i
              v-if="isUserEditableDerivedColumn(col)"
              class="fas fa-pencil-alt chip-edit"
              title="Edit custom formula"
              aria-label="Edit custom formula"
              @click.stop="openRatioModalForEdit(col)"
            />
            <i
              v-if="col && typeof col === 'object' && isNewLayoutColumn(col.base)"
              class="fas fa-certificate vizlet-col-new-icon"
              title="Added in your saved column layout (not in the screen default)."
              aria-label="New column from saved layout"
            />
            <span class="chip-remove" @click.stop="removeColumn(col)">&times;</span>
          </div>
        </draggable>
      </div>

      <div
        v-if="resolvedDataSourceMode === 'sql' && !useLegacyColumnList"
        class="vizlet-sql-query-section mb-2"
      >
        <label class="vizlet-sql-query-label small text-muted mb-1 d-block">
          SQL query
        </label>
        <b-form-textarea
          v-model="columnManagerSqlQuery"
          rows="3"
          max-rows="10"
          class="vizlet-sql-query-textarea"
          placeholder="SELECT …"
        />
        <span
          v-if="columnManagerSqlParseError"
          class="small text-danger d-block mt-1"
        >
          {{ columnManagerSqlParseError }}
        </span>
      </div>

      <div class="vizlet-col-mapping-section">
        <!-- <p class="text-muted vizlet-col-mapping-intro mb-2">
          Select columns to show in the table.
        </p> -->

        <VariableMappingPanel
          v-if="resolvedDataSourceMode && !useLegacyColumnList"
          :mode="resolvedDataSourceMode"
          :rows="filteredVizletMappingRows"
          :header-map="lastSavedHeaderMap || currentHeaderMap || {}"
          :search-query.sync="columnManagerMappingSearch"
          :loading="columnManagerCatalogLoading"
          :error="columnManagerMappingError"
          :visible-columns="visibleColumns"
          prioritize-included-rows
          context="vizlet"
          layout="drawer"
          @row-change="onVizletMappingRowChange"
          @set-all-include="onVizletSetAllInclude"
        />

        <template v-else>
          <b-alert
            v-if="columnManagerMappingError"
            show
            variant="warning"
            class="small py-2 mb-2"
          >
            {{ columnManagerMappingError }}
          </b-alert>
          <div class="column-checklist">
            <div
              v-for="col in columnSelection"
              :key="'chk-' + (col.alias || col.base)"
              class="column-check-item"
              :class="{ 'column-check-item--active': col.checked }"
              :title="columnListTooltip(col)"
            >
              <b-form-checkbox
                v-model="col.checked"
                @change="(checked) => addColumn(col, checked)"
                size="sm"
              >
                <span class="column-check-label">
                  <template v-if="col.isRenamed">
                    <span class="column-check-catalog-name">{{ col.base }}</span>
                    <span class="column-check-renamed-mark">(renamed)</span>
                    <span
                      v-if="columnCheckboxActualKey(col)"
                      class="column-check-actual-key"
                    >
                      ({{ columnCheckboxActualKey(col) }})</span
                    >
                  </template>
                  <template v-else>
                    {{ columnCheckboxDisplayLabel(col) }}
                  </template>
                </span>
              </b-form-checkbox>
              <div
                v-if="col.checked && isMetricToggleColumn(col)"
                class="ml-2 d-inline-flex align-items-center display-toggle"
              >
                <small class="text-muted mr-1">Display:</small>
                <b-form-radio-group
                  v-model="col.mode"
                  @change="onMetricModeChange(col)"
                  :options="[
                    { text: 'Int', value: 'metric' },
                    { text: 'Bar', value: 'graph' },
                  ]"
                  buttons
                  size="sm"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
      </div>

      <p class="mt-2 mb-0 text-muted vizlet-col-manager-footer-hint">
        Can't find the column you are looking for?
        <b-button
          variant="link"
          size="sm"
          class="p-0 align-baseline"
          @click="openRatioModal"
        >
          Create custom column
        </b-button>
      </p>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <div>
          <b-button variant="primary" size="sm" @click="saveColumns"
            >Save Columns</b-button
          >
          <b-button
            variant="outline-primary"
            size="sm"
            class="ml-2"
            title="Refresh the table with your column changes without saving to the server"
            @click="previewColumns"
            >Preview</b-button
          >
          <b-button
            variant="link"
            size="sm"
            class="ml-2"
            @click="cancelColumnManager"
            >Cancel</b-button
          >
        </div>
        <b-button variant="outline-danger" size="sm" @click="resetDefaults"
          >Reset Defaults</b-button
        >
      </div>
    </b-modal>

    <!-- Custom column: compact height, draggable header -->
    <b-modal
      ref="ratio-modal"
      :hide-footer="true"
      hide-backdrop
      no-close-on-backdrop
      no-fade
      :modal-class="['vizlet-header-ratio-drawer', drawerInstanceId]"
      dialog-class="vizlet-header-side-dialog vizlet-header-ratio-dialog"
      content-class="vizlet-header-drawer-content vizlet-header-ratio-drawer-content"
      @show="ensureRatioOptionsLoaded"
      @shown="onRatioDrawerShown"
      @hidden="onRatioDrawerHidden"
    >
      <template #modal-header="{ close }">
        <div class="d-flex align-items-center w-100 vizlet-drawer-header-row">
          <div
            class="flex-grow-1 d-flex align-items-center flex-wrap vizlet-drawer-drag-handle py-1 pr-1"
            title="Drag to move. Double-click to snap back to the left edge."
            @mousedown.stop="onRatioHeaderPointerDown"
            @touchstart.stop.prevent="onRatioHeaderTouchStart"
            @dblclick.stop="resetDrawerPosition('ratio')"
          >
            <h5 class="mb-0 vizlet-drawer-title">{{ ratioModalTitle }}</h5>
            <i class="fas fa-grip-vertical ml-2 text-muted vizlet-drawer-grip" aria-hidden="true" />
          </div>
          <b-button-close
            class="vizlet-drawer-close"
            @mousedown.stop
            @click="close"
          />
        </div>
      </template>
      <div>
        <b-alert
          v-if="ratioModalValidationError"
          show
          variant="danger"
          class="mb-3 vizlet-drawer-alert fw-copyable-text"
          tabindex="0"
          @keydown="onCopyableRegionKeydown"
        >
          <div>{{ ratioModalValidationError }}</div>
          <template v-if="ratioModalValidationErrorQuery">
            <div class="vizlet-error-query-header mt-2 mb-1">
              <span class="small text-muted mb-0">Query that caused the error:</span>
              <b-button
                size="sm"
                :variant="ratioErrorQueryCopied ? 'success' : 'outline-secondary'"
                class="vizlet-error-query-copy-btn"
                @click.stop="copyRatioErrorQuery"
              >
                {{ ratioErrorQueryCopied ? "Copied" : "Copy" }}
              </b-button>
            </div>
            <pre ref="ratioErrorQueryPre" class="vizlet-fetch-error-query mb-0">{{ ratioModalValidationErrorQuery }}</pre>
            <textarea
              ref="ratioErrorQueryCopySource"
              class="vizlet-error-query-copy-source"
              readonly
              tabindex="-1"
              aria-hidden="true"
              :value="ratioModalValidationErrorQuery"
            />
          </template>
        </b-alert>
        <b-form-group label="Display name" label-for="ratio-display-name">
          <b-form-input
            id="ratio-display-name"
            v-model.trim="ratioDisplayName"
            placeholder="Enter column display name"
          />
        </b-form-group>

        <b-form-group label="Illustrative Variable" label-for="ratio-select">
          <b-form-select
            id="ratio-select"
            v-model="selectedRatioFormula"
            :options="ratioDropdownOptions"
            :disabled="isLoadingRatioOptions"
            @change="onRatioSelected"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>
                Select a predefined Illustrative Variable
              </b-form-select-option>
            </template>
          </b-form-select>
          <small v-if="ratioOptionsLoadError" class="text-danger">
            {{ ratioOptionsLoadError }}
          </small>
        </b-form-group>

        <b-form-group
          v-if="showRatioFormulaEditor"
          label-for="ratio-formula"
        >
          <template #label>
            <span class="d-inline-flex align-items-center flex-wrap vizlet-formula-label">
              <span>Illustrative Formula</span>
              <b-badge
                variant="light"
                class="ml-2 font-weight-normal border vizlet-formula-editable-badge"
                pill
              >
                <i class="fas fa-pen mr-1" aria-hidden="true"></i>
                Editable
              </b-badge>
            </span>
          </template>
          <b-form-textarea
            id="ratio-formula"
            v-model="ratioFormula"
            rows="4"
            max-rows="8"
            class="vizlet-formula-textarea"
            placeholder="Edit the formula here before saving…"
            aria-describedby="ratio-formula-help"
          />
          <b-form-text id="ratio-formula-help" class="mt-1 mb-0">
            <i class="fas fa-info-circle mr-1" aria-hidden="true"></i>
            You can change this text; it is not read-only.
          </b-form-text>
        </b-form-group>

        <div class="d-flex justify-content-end mt-3">
          <b-button
            variant="secondary"
            size="sm"
            class="mr-2"
            @click="$refs['ratio-modal'].hide()"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            :disabled="!canSaveRatio || isSavingRatio"
            @click="saveDerivedRatio"
          >
            {{ isSavingRatio ? 'Validating...' : ratioModalSaveLabel }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- AI Insights Chat Modal -->
    <b-modal
      ref="ai-chat-modal"
      title="AI Insights"
      size="lg"
      hide-footer
      no-close-on-backdrop
      body-class="p-0"
      @hidden="onAiChatHidden"
    >
      <template #modal-title>
        <div class="d-flex align-items-center">
          <svg class="gemini-svg gemini-modal-icon" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 0C14 7.732 7.732 14 0 14c7.732 0 14 6.268 14 14 0-7.732 6.268-14 14-14-7.732 0-14-6.268-14-14z" fill="currentColor"/>
          </svg>
          <span class="ml-2">AI Insights &mdash; {{ viz1.vizletTitleDpName }}</span>
        </div>
      </template>

      <div class="ai-chat-body">
        <div v-if="aiChatScreenshot || vizData" class="ai-chat-screenshot-bar">
          <img
            v-if="aiChatScreenshot"
            :src="screenshotPreviewUrl"
            class="ai-chat-screenshot-thumb"
            alt="Dashboard screenshot"
            title="Screenshot sent to AI"
          />
          <span v-if="aiChatScreenshot" class="ai-chat-attachment-tag">
            <i class="fas fa-image"></i> Screenshot
          </span>
          <span v-if="vizData" class="ai-chat-attachment-tag data-tag">
            <i class="fas fa-database"></i> {{ vizDataRowCount }} rows
          </span>
        </div>
        <div class="ai-chat-messages" ref="aiChatMessages">
          <div
            v-for="(msg, idx) in aiChatMessages"
            :key="idx"
            :class="['ai-chat-msg', msg.role]"
          >
            <div class="ai-chat-avatar" v-if="msg.role === 'assistant'">
              <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                <path d="M14 0C14 7.732 7.732 14 0 14c7.732 0 14 6.268 14 14 0-7.732 6.268-14 14-14-7.732 0-14-6.268-14-14z" fill="#4285F4"/>
              </svg>
            </div>
            <div class="ai-chat-avatar user-avatar" v-else>U</div>
            <div class="ai-chat-bubble">
              <div class="ai-chat-text" v-html="formatAiText(msg.content)"></div>
            </div>
          </div>

          <div v-if="aiChatLoading" class="ai-chat-msg assistant">
            <div class="ai-chat-avatar">
              <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                <path d="M14 0C14 7.732 7.732 14 0 14c7.732 0 14 6.268 14 14 0-7.732 6.268-14 14-14-7.732 0-14-6.268-14-14z" fill="#4285F4"/>
              </svg>
            </div>
            <div class="ai-chat-bubble">
              <div class="ai-typing-indicator">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="aiChatError" class="ai-chat-error">{{ aiChatError }}</div>

        <form class="ai-chat-input-area" @submit.prevent="sendAiChat">
          <textarea
            v-model="aiChatInput"
            class="ai-chat-input"
            placeholder="Ask a follow-up question..."
            rows="1"
            @keydown.enter.exact.prevent="sendAiChat"
          ></textarea>
          <button
            type="submit"
            class="ai-chat-send-btn"
            :disabled="aiChatLoading || !aiChatInput.trim()"
          >
            <i class="fas fa-paper-plane"></i>
          </button>
        </form>
      </div>
    </b-modal>

    <div v-if="$store.state.deviceType === 'Mobile'">
      <span
        @click="$emit('toggle-body')"
        :title="isCollapsed ? 'Expand' : 'Collapse'"
      >
        <i
          class="fas"
          :class="isCollapsed ? 'fa-caret-square-down' : 'fa-caret-square-up'"
        ></i>
      </span>

      <span
        v-for="(ai, index) in mCurrentMenuActionIconsData"
        :key="'m-' + index"
      >
        <span @click="$emit('action', ai.functionName, index, ai)">
          <i
            :id="ai.iconId"
            :class="[
              iconOnChangeFlag[index] === true
                ? ai.iconClass
                : ai.iconOnchangeClass,
            ]"
            :title="
              iconOnChangeFlag[index] ? ai.iconTooltip : ai.iconOnchangeTooltip
            "
            style="font-size:15px; padding-left:10px;"
          ></i>
        </span>
      </span>
    </div>

    <div v-else>
      <span
        v-if="viz1.viztypeName === 'TableBar'"
        title="Clear Filter"
        @click="$emit('reset-filter')"
      >
        <i class="fas fa-solid fa-filter"></i>
      </span>

      <span
        v-if="vizCount === 1"
        style="margin: 10px"
        :title="fixedScreen ? 'Collapse Size' : 'Expand Size'"
        @click="$emit('toggle-width')"
      >
        <i
          class="fas"
          :class="fixedScreen ? 'fa-solid fa-expand' : 'fa-solid fa-compress'"
        ></i>
      </span>

      <span
        @click="$emit('toggle-body')"
        :title="isCollapsed ? 'Expand' : 'Collapse'"
      >
        <i
          class="fas"
          :class="isCollapsed ? 'fa-caret-square-down' : 'fa-caret-square-up'"
        ></i>
      </span>

      <span
        v-for="(ai, index) in currentMenuActionIconsData"
        :key="'d-' + index"
      >
        <span @click="$emit('action', ai.functionName, index, ai)">
          <i
            :id="ai.iconId"
            :class="[
              iconOnChangeFlag[index] === true
                ? ai.iconClass
                : ai.iconOnchangeClass,
            ]"
            :title="
              iconOnChangeFlag[index] ? ai.iconTooltip : ai.iconOnchangeTooltip
            "
            style="font-size:15px; padding-left:10px;"
          ></i>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from "axios";
import html2canvas from "html2canvas";
import VariableMappingPanel from "@/components/variable-mapping/VariableMappingPanel.vue";
import {
  normalizeDataSourceMode,
  stripSelectAliasesFromSql,
  validateReadOnlySelectSql,
  chipsFromReportHeaderMap,
  headerMapHasGraphCompanion,
} from "@/common/columnMappingCore";
import {
  assignChartAliasesToRows,
  buildVizletSqlModeColumnLayout,
  buildVizletTableBarColumnLayout,
  syncSqlModeMappingRowsFromSql,
} from "@/common/columnMappingTableSql";
import {
  loadVariableMappingRows,
  getFilteredMappingRows,
  syncSelectionFromMapping,
} from "@/composables/useVariableMapping";
import {
  acquireSelectionLock,
  releaseSelectionLock,
  forceReleaseSelectionLock,
  onCopyableRegionKeydown,
  copyTextToClipboard,
} from "@/common/selectionLock";
import { partitionIncludedMappingRowsFirst } from "@/common/mappingTableSort";
import InlineTitleField from "@/components/inline_title_field.vue";

export default {
  name: "VizletHeader",
  components: { draggable, InlineTitleField, VariableMappingPanel },
  props: {
    viz1: { type: Object, required: true },
    vizData: { type: [Array, Object], default: null },
    currentMenuActionIconsData: { type: Array, default: () => [] },
    mCurrentMenuActionIconsData: { type: Array, default: () => [] },
    vizCount: { type: Number, default: 1 },
    configEditMode: { type: Boolean, default: false },
    searchQuery: { type: String, default: "" },
    iconOnChangeFlag: { type: Array, default: () => [] },
    isCollapsed: { type: Boolean, default: false },
    format: { type: Function, default: (v) => v },
    total: { type: [String, Number], default: "" },
    headerMap: { type: Object, default: null },
    allHeaderMap: { type: Object, default: null },
    /** Display labels (reportHeaderColumnDp keys) added vs screen default — from vizlet */
    reportHeaderNewColumnTitles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localSearchQuery: this.searchQuery || "",
      visibleColumns: [],
      columnSelection: [],
      originalHeaderMap: null,
      defaultHeaderMap: null,
      lastSavedHeaderMap: null,
      derivedColumnLocal: {},
      /** When set, ratio modal updates this metric alias instead of creating a new one */
      ratioEditAlias: null,
      // Derived ratio modal state
      ratioDisplayName: "",
      ratioDropdownOptions: [],
      selectedRatioFormula: null,
      /** Predefined formula from API; stays fixed while user edits the textarea. */
      ratioTemplateFormula: null,
      ratioFormula: "",
      isLoadingRatioOptions: false,
      ratioOptionsLoaded: false,
      ratioOptionsLoadError: "",
      isSavingRatio: false,
      /** Skip onRatioSelected while programmatically filling the ratio modal (avoids wiping formula textarea). */
      ratioModalHydrating: false,
      /** Server rejected preview while validating custom formula from this modal */
      ratioModalValidationError: null,
      ratioModalValidationErrorQuery: null,
      ratioErrorQueryCopied: false,
      /** True after Validate clicked until parent preview fetch completes */
      ratioValidatePreviewPending: false,
      // AI Chat state
      aiChatMessages: [],
      aiChatInput: "",
      aiChatLoading: false,
      aiChatError: null,
      aiChatSessionId: null,
      aiChatScreenshot: null,
      /** Set when TableBar column preview/save refetch fails; cleared when modal opens/closes normally */
      columnManagerFetchError: null,
      columnManagerFetchErrorQuery: null,
      /** SQL sent on last Preview/Save column layout (for fetch error display). */
      lastColumnLayoutFetchSql: "",
      /** Refcount for side drawers; used to restore body scroll (BV 2.x adds modal-open) */
      sideDrawerModalCount: 0,
      /** Drag offset (px) for portaled .modal-dialog — transform translate */
      colManagerDialogOffset: { x: 0, y: 0 },
      ratioDialogOffset: { x: 0, y: 0 },
      /** User-resized column manager drawer (persisted in sessionStorage) */
      colManagerDrawerSize: { width: 580, height: 0 },
      /** Active drag: { kind, startX, startY, originX, originY } */
      drawerDrag: null,
      /** Active resize: { axis, startX, startY, startW, startH } */
      drawerResize: null,
      /** Unique class on portaled modals so we can find .modal-dialog in document */
      drawerInstanceId:
        "vzh" + Math.random().toString(36).slice(2, 11),
      /** Dropdown value used for fully custom formula entry */
      ratioOtherOptionValue: "__RATIO_OTHER__",
      /** active chip key when inline column name edit is enabled */
      editingColumnChipKey: null,
      resolvedDataSourceMode: null,
      vizletMappingRows: [],
      columnManagerMappingSearch: "",
      columnManagerCatalogLoading: false,
      columnManagerMappingError: null,
      useLegacyColumnList: false,
      tableBarSqlLocal: "",
      columnManagerSqlQuery: "",
      columnManagerSqlParseError: null,
      /** Alias-free SQL from last Preview/Save in column manager (session). */
      columnManagerSqlDraft: "",
      /** Mapping rows from last Preview/Save (session). */
      columnManagerMappingRowsDraft: null,
      /** Production SQL with chart aliases from last Preview/Save (session). */
      columnManagerAliasedSqlDraft: "",
    };
  },
  watch: {
    searchQuery(newVal) {
      this.localSearchQuery = newVal;
    },
    columnManagerSqlQuery(sql) {
      if (this.resolvedDataSourceMode !== "sql") return;
      if (this.useLegacyColumnList) return;
      if (this.columnManagerCatalogLoading) return;
      this.syncColumnManagerSqlFromQuery(sql);
    },
    ratioModalValidationErrorQuery() {
      this.resetRatioErrorQueryCopied();
    },
  },
  computed: {
    fixedScreen() {
      return this.$store.state.fixedScreen;
    },
    currentHeaderMap() {
      return this.headerMap || this.viz1.reportHeaderColumnDp || {};
    },
    canSaveRatio() {
      return (
        !!this.ratioDisplayName &&
        !!this.ratioFormula &&
        !this.isSavingRatio
      );
    },
    ratioModalTitle() {
      return this.ratioEditAlias
        ? "Edit ratio column"
        : "Create new ratio column";
    },
    ratioModalSaveLabel() {
      return this.ratioEditAlias ? "Validate" : "Validate";
    },
    showRatioFormulaEditor() {
      return !!this.selectedRatioFormula || !!this.ratioEditAlias;
    },
    screenshotPreviewUrl() {
      if (!this.aiChatScreenshot) return null;
      return URL.createObjectURL(this.aiChatScreenshot);
    },
    vizDataRowCount() {
      if (!this.vizData) return 0;
      return Array.isArray(this.vizData) ? this.vizData.length : 1;
    },
    filteredVizletMappingRows() {
      let rows = getFilteredMappingRows(
        this.vizletMappingRows,
        this.columnManagerMappingSearch,
        this.resolvedDataSourceMode,
      );
      if (this.resolvedDataSourceMode === "table") {
        rows = partitionIncludedMappingRowsFirst(
          rows,
          "table",
          this.visibleColumns,
        );
      }
      return rows;
    },
  },
  mounted() {
    window.addEventListener("resize", this.onDrawerWindowResize, { passive: true });
    this.loadColManagerDrawerSize();
  },
  methods: {
    emitVizletTitleSave(field, value) {
      this.$emit("vizlet-title-save", { field, value });
    },
    getDrawerDialogEl(modalRef) {
      const baseClass =
        modalRef === "col-manager-modal"
          ? "vizlet-header-col-manager-drawer"
          : "vizlet-header-ratio-drawer";
      const id = this.drawerInstanceId;
      if (typeof document !== "undefined" && id) {
        const root = document.querySelector(
          `div.modal.${baseClass}.${id}`,
        );
        if (root) {
          const dlg = root.querySelector(".modal-dialog");
          if (dlg) return dlg;
        }
      }
      const comp = this.$refs[modalRef];
      const el = comp && comp.$el;
      if (el && typeof el.querySelector === "function") {
        return el.querySelector(".modal-dialog");
      }
      return null;
    },

    applyDrawerTransform(kind) {
      const refName = kind === "col-manager" ? "col-manager-modal" : "ratio-modal";
      const dlg = this.getDrawerDialogEl(refName);
      if (!dlg) return;
      const off =
        kind === "col-manager"
          ? this.colManagerDialogOffset
          : this.ratioDialogOffset;
      dlg.style.transform = `translate(${off.x}px, ${off.y}px)`;
    },

    loadColManagerDrawerSize() {
      if (typeof window === "undefined") return;
      try {
        const raw = window.sessionStorage.getItem("fw_vizlet_col_manager_size");
        if (!raw) return;
        const parsed = JSON.parse(raw);
        const w = Number(parsed && parsed.width);
        const h = Number(parsed && parsed.height);
        if (w >= 360 && w <= 2400) {
          this.colManagerDrawerSize = {
            width: Math.round(w),
            height: h > 0 ? Math.round(h) : 0,
          };
        }
      } catch {
        /* ignore */
      }
    },

    saveColManagerDrawerSize() {
      if (typeof window === "undefined") return;
      try {
        window.sessionStorage.setItem(
          "fw_vizlet_col_manager_size",
          JSON.stringify(this.colManagerDrawerSize),
        );
      } catch {
        /* ignore */
      }
    },

    applyColManagerDrawerLayout() {
      const dlg = this.getDrawerDialogEl("col-manager-modal");
      if (!dlg || typeof window === "undefined") return;
      const content = dlg.querySelector(".modal-content");
      const maxW = Math.max(360, window.innerWidth - 16);
      const maxH = Math.max(280, window.innerHeight - 16);
      const w = Math.round(
        Math.min(maxW, Math.max(360, this.colManagerDrawerSize.width || 580)),
      );
      const hRaw = Number(this.colManagerDrawerSize.height) || 0;
      dlg.style.setProperty("width", `${w}px`, "important");
      dlg.style.setProperty("max-width", `${w}px`, "important");
      if (hRaw > 0) {
        const h = Math.round(Math.min(maxH, Math.max(280, hRaw)));
        dlg.style.setProperty("height", `${h}px`, "important");
        dlg.style.setProperty("max-height", `${h}px`, "important");
        dlg.style.setProperty("min-height", `${h}px`, "important");
        dlg.classList.add("vizlet-header-col-manager-dialog--resized");
        if (content) {
          content.style.setProperty("height", "100%", "important");
          content.style.setProperty("max-height", "100%", "important");
          content.style.setProperty("min-height", "0", "important");
          content.style.setProperty("display", "flex", "important");
          content.style.setProperty("flex-direction", "column", "important");
        }
        this.colManagerDrawerSize = { width: w, height: h };
      } else {
        dlg.style.removeProperty("height");
        dlg.style.removeProperty("max-height");
        dlg.style.removeProperty("min-height");
        dlg.classList.remove("vizlet-header-col-manager-dialog--resized");
        if (content) {
          content.style.removeProperty("height");
          content.style.removeProperty("max-height");
          content.style.removeProperty("min-height");
        }
        this.colManagerDrawerSize = { width: w, height: 0 };
      }
      this.applyDrawerTransform("col-manager");
    },

    ensureColManagerResizeHandles() {
      const dlg = this.getDrawerDialogEl("col-manager-modal");
      if (!dlg || dlg.__vzhResizeBound) return;
      const bind = (el, axis) => {
        const handler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.onColManagerResizeStart(e, axis);
        };
        el.addEventListener("mousedown", handler, true);
      };
      const corner = document.createElement("div");
      corner.className = "vizlet-drawer-resize-corner";
      corner.setAttribute("title", "Drag to resize width and height");
      corner.setAttribute("aria-label", "Resize panel");
      bind(corner, "se");
      dlg.appendChild(corner);

      const edgeR = document.createElement("div");
      edgeR.className =
        "vizlet-drawer-resize-edge vizlet-drawer-resize-edge--right";
      edgeR.setAttribute("title", "Drag to resize width");
      bind(edgeR, "e");
      dlg.appendChild(edgeR);

      const edgeB = document.createElement("div");
      edgeB.className =
        "vizlet-drawer-resize-edge vizlet-drawer-resize-edge--bottom";
      edgeB.setAttribute("title", "Drag to resize height");
      bind(edgeB, "s");
      dlg.appendChild(edgeB);

      dlg.__vzhResizeBound = true;
    },

    removeColManagerResizeHandles() {
      const dlg = this.getDrawerDialogEl("col-manager-modal");
      if (!dlg) return;
      dlg
        .querySelectorAll(
          ".vizlet-drawer-resize-corner, .vizlet-drawer-resize-edge",
        )
        .forEach((el) => el.remove());
      delete dlg.__vzhResizeBound;
    },

    onColManagerResizeStart(e, axis) {
      if (e.button !== 0) return;
      if (this.drawerDrag) this.onDrawerDragEnd();
      const dlg = this.getDrawerDialogEl("col-manager-modal");
      if (!dlg) return;
      const rect = dlg.getBoundingClientRect();
      this.drawerResize = {
        axis: axis || "se",
        startX: e.clientX,
        startY: e.clientY,
        startW: rect.width,
        startH: rect.height,
      };
      document.addEventListener("mousemove", this.onColManagerResizeMove);
      document.addEventListener("mouseup", this.onColManagerResizeEnd);
      document.body.classList.add("vizlet-header-drawer-resizing");
      acquireSelectionLock({
        cursor:
          axis === "e" ? "ew-resize" : axis === "s" ? "ns-resize" : "nwse-resize",
      });
    },

    onColManagerResizeMove(e) {
      if (!this.drawerResize) return;
      e.preventDefault();
      const axis = this.drawerResize.axis;
      const dx = e.clientX - this.drawerResize.startX;
      const dy = e.clientY - this.drawerResize.startY;
      let w = this.drawerResize.startW;
      let h = this.drawerResize.startH;
      if (axis === "e" || axis === "se") w += dx;
      if (axis === "s" || axis === "se") h += dy;
      const maxW = Math.max(360, window.innerWidth - 16);
      const maxH = Math.max(280, window.innerHeight - 16);
      w = Math.round(Math.min(maxW, Math.max(360, w)));
      h = Math.round(Math.min(maxH, Math.max(280, h)));
      this.colManagerDrawerSize = { width: w, height: h };
      this.applyColManagerDrawerLayout();
    },

    onColManagerResizeEnd() {
      document.removeEventListener("mousemove", this.onColManagerResizeMove);
      document.removeEventListener("mouseup", this.onColManagerResizeEnd);
      document.body.classList.remove("vizlet-header-drawer-resizing");
      releaseSelectionLock();
      this.drawerResize = null;
      this.saveColManagerDrawerSize();
      this.colManagerDialogOffset = this.clampDrawerOffset(
        "col-manager",
        this.colManagerDialogOffset.x,
        this.colManagerDialogOffset.y,
      );
      this.applyDrawerTransform("col-manager");
    },

    clampDrawerOffset(kind, x, y) {
      const refName = kind === "col-manager" ? "col-manager-modal" : "ratio-modal";
      const dlg = this.getDrawerDialogEl(refName);
      if (!dlg || typeof window === "undefined") return { x, y };
      const rect = dlg.getBoundingClientRect();
      const pad = 32;
      const w = rect.width || 320;
      const h = rect.height || 200;
      const minX = Math.min(0, -w + pad);
      const maxX = Math.max(0, window.innerWidth - pad);
      const minY = Math.min(0, -h + pad);
      const maxY = Math.max(0, window.innerHeight - pad);
      return {
        x: Math.round(Math.min(maxX, Math.max(minX, x))),
        y: Math.round(Math.min(maxY, Math.max(minY, y))),
      };
    },

    drawerHeaderTargetOk(target) {
      if (!target || !target.closest) return false;
      return !target.closest(
        "button, a, input, select, textarea, label, pre, .dropdown-menu, .alert, .vizlet-drawer-alert, .vizlet-fetch-error-query, .fw-copyable-text, .form-control, .custom-select, .vizlet-drawer-resize-corner, .vizlet-drawer-resize-edge, .col-manager-chips, .vizlet-sql-query-section, .mapping-table-wrap, .vizlet-col-mapping-section",
      );
    },

    bindDrawerSurfaceDrag(kind) {
      const refName = kind === "col-manager" ? "col-manager-modal" : "ratio-modal";
      const dlg = this.getDrawerDialogEl(refName);
      if (!dlg) return;
      const pointerHandler = (e) => this.onDrawerSurfacePointerDown(kind, e);
      const touchHandler = (e) => this.onDrawerSurfaceTouchStart(kind, e);
      dlg.__vizletDrawerPointerHandler = pointerHandler;
      dlg.__vizletDrawerTouchHandler = touchHandler;
      dlg.addEventListener("mousedown", pointerHandler);
      dlg.addEventListener("touchstart", touchHandler, { passive: false });
    },

    unbindDrawerSurfaceDrag(kind) {
      const refName = kind === "col-manager" ? "col-manager-modal" : "ratio-modal";
      const dlg = this.getDrawerDialogEl(refName);
      if (!dlg) return;
      if (dlg.__vizletDrawerPointerHandler) {
        dlg.removeEventListener("mousedown", dlg.__vizletDrawerPointerHandler);
        delete dlg.__vizletDrawerPointerHandler;
      }
      if (dlg.__vizletDrawerTouchHandler) {
        dlg.removeEventListener("touchstart", dlg.__vizletDrawerTouchHandler);
        delete dlg.__vizletDrawerTouchHandler;
      }
    },

    beginDrawerDrag(kind, clientX, clientY) {
      if (this.drawerDrag) {
        this.onDrawerDragEnd();
      }
      this.drawerDrag = {
        kind,
        startX: clientX,
        startY: clientY,
        originX:
          kind === "col-manager"
            ? this.colManagerDialogOffset.x
            : this.ratioDialogOffset.x,
        originY:
          kind === "col-manager"
            ? this.colManagerDialogOffset.y
            : this.ratioDialogOffset.y,
      };
      document.addEventListener("mousemove", this.onDrawerDragMove);
      document.addEventListener("mouseup", this.onDrawerDragEnd);
      document.addEventListener("touchmove", this.onDrawerDragMoveTouch, {
        passive: false,
      });
      document.addEventListener("touchend", this.onDrawerDragEnd);
      document.body.classList.add("vizlet-header-drawer-dragging");
      acquireSelectionLock();
    },

    onColManagerHeaderPointerDown(e) {
      if (e.button !== 0) return;
      if (!this.drawerHeaderTargetOk(e.target)) return;
      this.beginDrawerDrag("col-manager", e.clientX, e.clientY);
    },

    onRatioHeaderPointerDown(e) {
      if (e.button !== 0) return;
      if (!this.drawerHeaderTargetOk(e.target)) return;
      this.beginDrawerDrag("ratio", e.clientX, e.clientY);
    },

    onColManagerHeaderTouchStart(e) {
      if (!e.touches || !e.touches.length) return;
      if (!this.drawerHeaderTargetOk(e.target)) return;
      const t = e.touches[0];
      this.beginDrawerDrag("col-manager", t.clientX, t.clientY);
    },

    onRatioHeaderTouchStart(e) {
      if (!e.touches || !e.touches.length) return;
      if (!this.drawerHeaderTargetOk(e.target)) return;
      const t = e.touches[0];
      this.beginDrawerDrag("ratio", t.clientX, t.clientY);
    },

    onDrawerSurfacePointerDown(kind, e) {
      if (e.button !== 0) return;
      if (!this.drawerHeaderTargetOk(e.target)) return;
      this.beginDrawerDrag(kind, e.clientX, e.clientY);
    },

    onDrawerSurfaceTouchStart(kind, e) {
      if (!e.touches || !e.touches.length) return;
      if (!this.drawerHeaderTargetOk(e.target)) return;
      const t = e.touches[0];
      this.beginDrawerDrag(kind, t.clientX, t.clientY);
      e.preventDefault();
    },

    onDrawerDragMove(e) {
      if (!this.drawerDrag) return;
      const dx = e.clientX - this.drawerDrag.startX;
      const dy = e.clientY - this.drawerDrag.startY;
      let x = this.drawerDrag.originX + dx;
      let y = this.drawerDrag.originY + dy;
      const kind = this.drawerDrag.kind;
      const clamped = this.clampDrawerOffset(kind, x, y);
      if (kind === "col-manager") {
        this.colManagerDialogOffset = clamped;
      } else {
        this.ratioDialogOffset = clamped;
      }
      this.applyDrawerTransform(kind);
    },

    onDrawerDragMoveTouch(e) {
      if (!this.drawerDrag || !e.touches || !e.touches.length) return;
      e.preventDefault();
      const t = e.touches[0];
      this.onDrawerDragMove({
        clientX: t.clientX,
        clientY: t.clientY,
      });
    },

    onDrawerDragEnd() {
      document.removeEventListener("mousemove", this.onDrawerDragMove);
      document.removeEventListener("mouseup", this.onDrawerDragEnd);
      document.removeEventListener("touchmove", this.onDrawerDragMoveTouch);
      document.removeEventListener("touchend", this.onDrawerDragEnd);
      document.body.classList.remove("vizlet-header-drawer-dragging");
      releaseSelectionLock();
      this.drawerDrag = null;
    },

    onCopyableRegionKeydown,

    async copyRatioErrorQuery() {
      const fromData = this.ratioModalValidationErrorQuery;
      const pre = this.$refs.ratioErrorQueryPre;
      const source = this.$refs.ratioErrorQueryCopySource;
      const text =
        fromData != null && String(fromData).length
          ? String(fromData)
          : (pre && pre.textContent) || (source && source.value) || "";
      if (!text) return;

      const modalRoot =
        (this.$refs["ratio-modal"] && this.$refs["ratio-modal"].$el) ||
        (pre && pre.closest && pre.closest(".modal")) ||
        null;

      const ok = await copyTextToClipboard(text, {
        container: modalRoot,
        textareaEl: source || null,
      });
      if (ok) {
        this.markRatioErrorQueryCopied();
      }
    },

    markRatioErrorQueryCopied() {
      this.ratioErrorQueryCopied = true;
      clearTimeout(this._ratioErrorQueryCopiedTimer);
      this._ratioErrorQueryCopiedTimer = setTimeout(() => {
        this.ratioErrorQueryCopied = false;
      }, 2000);
    },

    resetRatioErrorQueryCopied() {
      this.ratioErrorQueryCopied = false;
      clearTimeout(this._ratioErrorQueryCopiedTimer);
      this._ratioErrorQueryCopiedTimer = null;
    },

    onDrawerWindowResize() {
      this.colManagerDialogOffset = this.clampDrawerOffset(
        "col-manager",
        this.colManagerDialogOffset.x,
        this.colManagerDialogOffset.y,
      );
      this.applyColManagerDrawerLayout();
      this.ratioDialogOffset = this.clampDrawerOffset(
        "ratio",
        this.ratioDialogOffset.x,
        this.ratioDialogOffset.y,
      );
      this.$nextTick(() => {
        this.applyDrawerTransform("col-manager");
        this.applyDrawerTransform("ratio");
      });
    },

    resetDrawerPosition(kind) {
      if (kind === "col-manager") {
        this.colManagerDialogOffset = { x: 0, y: 0 };
        this.applyDrawerTransform("col-manager");
      } else {
        this.ratioDialogOffset = { x: 0, y: 0 };
        this.applyDrawerTransform("ratio");
      }
    },

    /**
     * Place the ratio (custom column) dialog beside the column manager using viewport
     * geometry so it stays visually tied after the user drags the manager.
     */
    alignRatioModalRelativeToColumnManager() {
      this.$nextTick(() => {
        const colDlg = this.getDrawerDialogEl("col-manager-modal");
        if (!colDlg || typeof window === "undefined") return;
        const r = colDlg.getBoundingClientRect();
        if (r.width < 8 || r.height < 8) return;

        const gap = 10;
        let nx = Math.round(r.right + gap);
        const ny = Math.round(r.top);

        const ratioDlg = this.getDrawerDialogEl("ratio-modal");
        let rw = ratioDlg ? ratioDlg.getBoundingClientRect().width : 0;
        if (rw < 8) rw = 380;

        if (nx + rw > window.innerWidth - 12) {
          nx = Math.round(r.left - rw - gap);
        }

        const clamped = this.clampDrawerOffset("ratio", nx, ny);
        this.ratioDialogOffset = clamped;
        this.applyDrawerTransform("ratio");
      });
    },
    extractMetricNumbers(input) {
      const nums = new Set();
      if (!input) return nums;

      const addFromString = (s) => {
        if (!s || typeof s !== "string") return;
        const re = /metric(\d+)/gi;
        let m;
        while ((m = re.exec(s))) {
          const n = Number(m[1]);
          if (Number.isFinite(n)) nums.add(n);
        }
      };

      const addFromObjectValues = (obj) => {
        if (!obj || typeof obj !== "object") return;
        Object.values(obj).forEach((v) => {
          if (typeof v === "string") addFromString(v);
          else if (v && typeof v === "object" && typeof v.aliasKey === "string") {
            addFromString(v.aliasKey);
          }
        });
      };

      if (typeof input === "string") addFromString(input);
      else if (Array.isArray(input)) input.forEach((v) => addFromString(v));
      else if (typeof input === "object") addFromObjectValues(input);

      return nums;
    },

    /**
     * Metric indices (N) still referenced by the saved header map values
     * (metricN / graphN). Used to drop derived-column definitions when the
     * user removes the corresponding custom (or toggled) column.
     */
    getMetricIndicesFromHeaderMapValues(headerMap) {
      const used = new Set();
      if (!headerMap || typeof headerMap !== "object") return used;
      Object.values(headerMap).forEach((v) => {
        if (typeof v !== "string") return;
        const m = /^metric(\d+)$/i.exec(v) || /^graph(\d+)$/i.exec(v);
        if (m) used.add(Number(m[1]));
      });
      return used;
    },

    /**
     * Keep derived entries only when their metric key (e.g. metric5) is still
     * tied to a visible column via newMap values (metricN or graphN).
     */
    pruneDerivedColumnMap(derivedMap, headerMap) {
      const usedIndices = this.getMetricIndicesFromHeaderMapValues(headerMap);
      const out = {};
      Object.keys(derivedMap || {}).forEach((key) => {
        const nums = this.extractMetricNumbers(key);
        const single =
          nums.size === 1 ? Array.from(nums)[0] : null;
        if (single != null && usedIndices.has(single)) {
          out[key] = derivedMap[key];
        } else if (single == null && derivedMap[key] !== undefined) {
          // Non–metricN keys (legacy / unexpected): preserve
          out[key] = derivedMap[key];
        }
      });
      return out;
    },

    getNextMetricAlias() {
      const nums = new Set();

      // 1) Prefer viz datasql (explicit requirement)
      const datasql = this.viz1 && this.viz1.datasql;
      this.extractMetricNumbers(datasql).forEach((n) => nums.add(n));

      // 2) Include existing header maps / all header maps
      const headerMap = this.lastSavedHeaderMap || this.currentHeaderMap || {};
      const allHeaderMap =
        this.allHeaderMap || (this.viz1 && this.viz1.allHeaderColumnDp) || {};

      this.extractMetricNumbers(headerMap).forEach((n) => nums.add(n));
      this.extractMetricNumbers(allHeaderMap).forEach((n) => nums.add(n));

      // 2b) Include derived columns (formula -> metricN)
      const derivedFromViz =
        this.viz1 && (this.viz1.derivedColumn || this.viz1.derived_column);
      this.extractMetricNumbers(derivedFromViz).forEach((n) => nums.add(n));
      Object.keys(this.derivedColumnLocal || {}).forEach((k) => {
        this.extractMetricNumbers(k).forEach((n) => nums.add(n));
      });
      this.extractMetricNumbers(this.derivedColumnLocal).forEach((n) => nums.add(n));

      // 3) Include any aliases currently in visibleColumns
      (this.visibleColumns || []).forEach((c) => {
        const alias = c && typeof c === "object" ? c.alias : null;
        this.extractMetricNumbers(alias).forEach((n) => nums.add(n));
      });

      const max = nums.size ? Math.max(...Array.from(nums)) : 0;
      return `metric${max + 1}`;
    },

    openRatioModal() {
      this.ratioOptionsLoadError = "";
      this.ratioModalValidationError = null;
      this.ratioModalValidationErrorQuery = null;
      this.ratioEditAlias = null;
      this.resetRatioModalState();
      if (
        this.ratioOptionsLoaded &&
        Array.isArray(this.ratioDropdownOptions) &&
        this.ratioDropdownOptions.length === 1 &&
        this.ratioDropdownOptions[0] &&
        this.ratioDropdownOptions[0].value === this.ratioOtherOptionValue
      ) {
        this.selectedRatioFormula = this.ratioOtherOptionValue;
        this.onRatioSelected(this.ratioOtherOptionValue);
      }
      this.$refs["ratio-modal"].show();
      this.$nextTick(() => {
        this.$nextTick(() => this.alignRatioModalRelativeToColumnManager());
      });
    },

    getMergedDerivedSpec(alias) {
      if (!alias) return null;
      const viz = this.viz1 || {};
      const merged = {
        ...(viz.derivedColumn || viz.derived_column || {}),
        ...(this.derivedColumnLocal || {}),
      };
      return merged[alias] || null;
    },

    /**
     * Editable only for user-defined ratio columns: _userCreated from save, or
     * persisted formula text (textarea) from a previous client save — not bare server templates.
     */
    isUserEditableDerivedColumn(col) {
      if (!col || typeof col !== "object" || !col.alias) return false;
      const aliasStr = String(col.alias).trim();
      if (!/^metric\d+$/i.test(aliasStr)) return false;
      const def = this.getMergedDerivedSpec(aliasStr);
      if (!def || typeof def !== "object" || !def.templateFormula) return false;
      if (def._userCreated === true) return true;
      return (
        typeof def.formula === "string" && String(def.formula).trim() !== ""
      );
    },

    async openRatioModalForEdit(col) {
      if (!this.isUserEditableDerivedColumn(col)) return;
      this.ratioOptionsLoadError = "";
      this.ratioModalValidationError = null;
      this.ratioModalValidationErrorQuery = null;
      await this.ensureRatioOptionsLoaded();
      const aliasStr = String(col.alias).trim();
      const def = this.getMergedDerivedSpec(aliasStr);
      if (!def || typeof def !== "object") return;

      this.ratioModalHydrating = true;
      this.ratioEditAlias = aliasStr;
      this.ratioDisplayName = (col.base && String(col.base).trim()) || "";

      const templateFormula = String(def.templateFormula || "").trim();
      this.ratioTemplateFormula = templateFormula;

      let displayFormula =
        def.formulaDisplay != null && String(def.formulaDisplay).trim() !== ""
          ? String(def.formulaDisplay)
          : "";
      if (
        !displayFormula &&
        def.formula != null &&
        String(def.formula).trim() !== ""
      ) {
        displayFormula = this.reverseDbColumnsToDisplayInFormula(
          String(def.formula),
        );
      }
      this.ratioFormula = displayFormula || templateFormula;

      const match = (this.ratioDropdownOptions || []).find(
        (o) => o && String(o.value || "").trim() === templateFormula,
      );
      this.selectedRatioFormula = match
        ? match.value
        : templateFormula
          ? this.ratioOtherOptionValue
          : null;

      this.$refs["ratio-modal"].show();
      // Select may emit change after mount; don't let it replace the restored formula.
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.alignRatioModalRelativeToColumnManager();
          this.ratioModalHydrating = false;
        });
      });
    },

    async ensureRatioOptionsLoaded() {
      if (this.ratioOptionsLoaded || this.isLoadingRatioOptions) {
        return;
      }
      this.isLoadingRatioOptions = true;
      this.ratioOptionsLoadError = "";
      try {
        // API: /api/getRatios returns objects of FwConfigMFormulae
        // { formulaName: 'Profit Margin', formula: 'SUM([Profit]) / NULLIF(SUM([Sales]),0)', ... }
        const { data } = await axios.get("/api/getRatios");
        const list = Array.isArray(data) ? data : [];
        const predefined = list.map((item, index) => ({
          value: item.formula,
          text: item.formulaName || `Ratio ${index + 1}`,
        }));
        this.ratioDropdownOptions = [
          ...predefined,
          { value: this.ratioOtherOptionValue, text: "Other" },
        ];
        if (!predefined.length && !this.ratioEditAlias) {
          this.selectedRatioFormula = this.ratioOtherOptionValue;
          this.onRatioSelected(this.ratioOtherOptionValue);
        }
        this.ratioOptionsLoaded = true;
      } catch (e) {
        this.ratioDropdownOptions = [
          { value: this.ratioOtherOptionValue, text: "Other" },
        ];
        if (!this.ratioEditAlias) {
          this.selectedRatioFormula = this.ratioOtherOptionValue;
          this.onRatioSelected(this.ratioOtherOptionValue);
        }
        this.ratioOptionsLoadError =
          "Unable to load predefined ratios. Please try again later.";
      } finally {
        this.isLoadingRatioOptions = false;
      }
    },

    onRatioSelected(formula) {
      if (this.ratioModalHydrating) return;
      if (formula === this.ratioOtherOptionValue) {
        this.ratioTemplateFormula = this.ratioOtherOptionValue;
        // Keep any typed value; just ensure editor is open and focused.
        this.$nextTick(() => {
          const el = this.$el && this.$el.querySelector("#ratio-formula");
          if (el && typeof el.focus === "function") el.focus();
        });
        return;
      }
      const t = formula || "";
      this.ratioTemplateFormula = t;
      this.ratioFormula = t;
    },

    extractBracketColumns(formula) {
      if (!formula || typeof formula !== "string") return [];
      const re = /\[[^\]]+\]/g;
      const out = [];
      let m;
      while ((m = re.exec(formula))) {
        out.push(m[0].slice(1, -1).trim());
      }
      return out;
    },

    /**
     * Replace header display names (allHeaderMap keys) with dbColumn in formula text.
     * Unmapped names stay as typed. Bracketed [DisplayName] and bare words are supported.
     * Bare-word replacement skips map keys that match common aggregate names so "sum(Cost)" is safe.
     */
    substituteHeaderDisplayNamesInFormula(formula) {
      if (!formula || typeof formula !== "string") return formula;
      const map = this.fullAllHeaderMapRef();
      if (!map || typeof map !== "object") return formula;

      const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      /** Do not replace bare tokens like "sum" in sum(Cost) */
      const skipBareForDisplayKey = (displayKey) =>
        /^(sum|avg|count|min|max|round|nullif|coalesce)$/i.test(
          String(displayKey).trim(),
        );

      const pairs = Object.keys(map)
        .map((name) => ({
          name,
          db: this.resolveDbColumn(map[name]),
        }))
        .filter((p) => p.name && p.db);
      pairs.sort((a, b) => b.name.length - a.name.length);

      let out = formula;
      for (const { name, db } of pairs) {
        const esc = escapeRe(name);
        out = out.replace(new RegExp(`\\[\\s*${esc}\\s*\\]`, "gi"), db);
        if (!skipBareForDisplayKey(name)) {
          out = out.replace(new RegExp(`\\b${esc}\\b`, "gi"), db);
        }
      }
      return out;
    },

    /**
     * Best-effort inverse of substituteHeaderDisplayNamesInFormula: replace physical
     * db columns (e.g. m1004) with allHeaderMap display keys for the formula editor.
     */
    reverseDbColumnsToDisplayInFormula(formula) {
      if (!formula || typeof formula !== "string") return formula;
      const map = this.fullAllHeaderMapRef();
      if (!map || typeof map !== "object") return formula;

      const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const pairs = Object.keys(map)
        .map((name) => ({
          name,
          db: this.resolveDbColumn(map[name]),
        }))
        .filter((p) => p.name && p.db);
      pairs.sort((a, b) => b.db.length - a.db.length);

      let out = formula;
      for (const { name, db } of pairs) {
        const esc = escapeRe(db);
        out = out.replace(new RegExp(`\\b${esc}\\b`, "g"), name);
      }
      return out;
    },

    saveDerivedRatio() {
      if (!this.canSaveRatio || this.isSavingRatio) return;
      this.isSavingRatio = true;
      try {
        const rawFormula = String(this.ratioFormula || "");
        const formulaStr =
          this.substituteHeaderDisplayNamesInFormula(rawFormula);
        let userColumns = this.extractBracketColumns(rawFormula);
        if (!userColumns.length) {
          userColumns = this.extractBracketColumns(formulaStr);
        }
        const selectedOther =
          this.selectedRatioFormula === this.ratioOtherOptionValue;
        const templateFormula = selectedOther
          ? String(rawFormula || "").trim()
          : String(this.ratioTemplateFormula || "").trim();
        const base = String(this.ratioDisplayName || "").trim();

        const derivedEntry = {
          templateFormula,
          userColumns,
          _userCreated: true,
          /** Resolved for SQL / compileUserDerivedFormula (e.g. m1004 tokens). */
          formula: formulaStr,
          /** Exact text the user typed (e.g. SUM(Sales)) for UI and edits. */
          formulaDisplay: rawFormula,
        };

        const isEdit = !!this.ratioEditAlias;
        let alias = isEdit ? this.ratioEditAlias : "";
        if (!alias && base) {
          const chip = (this.visibleColumns || []).find(
            (c) =>
              c &&
              typeof c === "object" &&
              String(c.base || "").trim() === base,
          );
          const cand =
            chip && chip.alias != null ? String(chip.alias).trim() : "";
          if (/^metric\d+$/i.test(cand)) {
            const prev = (this.derivedColumnLocal || {})[cand];
            if (prev && prev._userCreated === true) {
              alias = cand;
            }
          }
        }
        if (!alias) {
          alias = this.getNextMetricAlias();
        }

        const effectiveTemplate =
          templateFormula || String(formulaStr || "").trim();
        if (!alias || !effectiveTemplate) {
          this.isSavingRatio = false;
          return;
        }

        this.derivedColumnLocal = {
          ...(this.derivedColumnLocal || {}),
          [alias]: { ...derivedEntry, templateFormula: effectiveTemplate },
        };

        if (base) {
          if (isEdit) {
            const idx = (this.visibleColumns || []).findIndex(
              (c) => c && String(c.alias || "") === String(alias),
            );
            if (idx !== -1) {
              this.visibleColumns.splice(idx, 1, {
                ...this.visibleColumns[idx],
                base,
                alias,
              });
            }
          } else {
            const exists = (this.visibleColumns || []).some(
              (c) => c && (c.base || c) === base,
            );
            if (!exists) {
              this.visibleColumns.push({ base, alias });
            } else {
              const idx = this.visibleColumns.findIndex(
                (c) => c && (c.base || c) === base,
              );
              if (idx !== -1) {
                this.visibleColumns[idx] = {
                  ...this.visibleColumns[idx],
                  base,
                  alias,
                };
              }
            }
          }
        }

        const payload = {
          displayName: base,
          formula: formulaStr,
          formulaDisplay: rawFormula,
          templateFormula,
          userColumns,
          alias,
        };
        this.$emit("create-derived-column", payload);
        this.ratioModalValidationError = null;
        this.ratioModalValidationErrorQuery = null;
        this.ratioValidatePreviewPending = true;
        this.previewColumns({
          keepColumnManagerOpen: true,
          ratioValidate: true,
        });
      } catch (e) {
        console.error("saveDerivedRatio", e);
        this.ratioValidatePreviewPending = false;
        this.isSavingRatio = false;
      }
    },

    /**
     * Called from vizlet (or screenlet relay) after preview fetch for Validate.
     */
    onRatioValidatePreviewResult({ success, message, query } = {}) {
      if (!this.ratioValidatePreviewPending) return;
      this.ratioValidatePreviewPending = false;
      this.isSavingRatio = false;
      if (success) {
        this.ratioModalValidationError = null;
        this.ratioModalValidationErrorQuery = null;
        this.$refs["ratio-modal"].hide();
        this.resetRatioModalState();
        this.$refs["col-manager-modal"].hide();
      } else {
        this.ratioModalValidationError =
          message ||
          "This formula could not be applied. Correct it below and click Validate again.";
        const q =
          query !== undefined && query !== null
            ? String(query).trim()
            : this.resolveColumnLayoutFetchSqlDisplay();
        this.ratioModalValidationErrorQuery = q || null;
        this.$nextTick(() => {
          const m = this.$refs["ratio-modal"];
          if (m && typeof m.show === "function") m.show();
          this.$nextTick(() => this.alignRatioModalRelativeToColumnManager());
        });
      }
    },

    resetRatioModalState() {
      this.ratioEditAlias = null;
      this.ratioDisplayName = "";
      this.selectedRatioFormula = null;
      this.ratioTemplateFormula = null;
      this.ratioFormula = "";
      this.ratioModalHydrating = false;
    },

    onRatioModalHidden() {
      if (this.ratioValidatePreviewPending) {
        this.ratioValidatePreviewPending = false;
        this.isSavingRatio = false;
      }
      this.resetRatioErrorQueryCopied();
      this.resetRatioModalState();
      this.ratioModalValidationError = null;
      this.ratioModalValidationErrorQuery = null;
    },

    onColumnManagerModalHidden() {
      this.columnManagerFetchError = null;
    },

    syncSideDrawerBodyClass() {
      if (this.sideDrawerModalCount > 0) {
        document.body.classList.add("vizlet-header-side-drawer-open");
      } else {
        document.body.classList.remove("vizlet-header-side-drawer-open");
      }
    },
    onColumnManagerDrawerShown() {
      this.sideDrawerModalCount += 1;
      this.syncSideDrawerBodyClass();
      this.colManagerDialogOffset = this.clampDrawerOffset(
        "col-manager",
        this.colManagerDialogOffset.x,
        this.colManagerDialogOffset.y,
      );
      this.$nextTick(() => {
        this.applyColManagerDrawerLayout();
        this.ensureColManagerResizeHandles();
        this.applyDrawerTransform("col-manager");
      });
    },
    onColumnManagerDrawerHidden() {
      this.editingColumnChipKey = null;
      this.removeColManagerResizeHandles();
      this.onColManagerResizeEnd();
      this.onDrawerDragEnd();
      this.saveColManagerDrawerSize();
      this.onColumnManagerModalHidden();
      this.sideDrawerModalCount = Math.max(0, this.sideDrawerModalCount - 1);
      this.syncSideDrawerBodyClass();
    },
    onRatioDrawerShown() {
      this.sideDrawerModalCount += 1;
      this.syncSideDrawerBodyClass();
      this.ratioDialogOffset = this.clampDrawerOffset(
        "ratio",
        this.ratioDialogOffset.x,
        this.ratioDialogOffset.y,
      );
      this.$nextTick(() => this.applyDrawerTransform("ratio"));
    },
    onRatioDrawerHidden() {
      this.onDrawerDragEnd();
      this.onRatioModalHidden();
      this.sideDrawerModalCount = Math.max(0, this.sideDrawerModalCount - 1);
      this.syncSideDrawerBodyClass();
    },

    /**
     * Reopen Column Manager after /api/fetchDataWithParam fails during Preview/Save.
     * Keeps existing chip/checklist state from before the modal was hidden.
     */
    showColumnManagerAfterFetchError(message, query) {
      const text =
        message ||
        "Please correct your custom column formula, then try Preview or Save again.";
      this.columnManagerFetchError = text;
      const q =
        query !== undefined && query !== null
          ? String(query).trim()
          : this.resolveColumnLayoutFetchSqlDisplay();
      this.columnManagerFetchErrorQuery = q || null;
      this.$nextTick(() => {
        const m = this.$refs["col-manager-modal"];
        if (m && typeof m.show === "function") m.show();
      });
    },

    rememberColumnLayoutFetchSql(tableBarSql, datasqlToSave) {
      const sql = String(
        tableBarSql ||
          datasqlToSave ||
          this.tableBarSqlLocal ||
          (this.resolvedDataSourceMode === "sql"
            ? this.columnManagerSqlQuery
            : "") ||
          "",
      ).trim();
      if (sql) {
        this.lastColumnLayoutFetchSql = sql;
      }
    },

    resolveColumnLayoutFetchSqlDisplay() {
      return String(
        this.lastColumnLayoutFetchSql ||
          (this.resolvedDataSourceMode === "sql"
            ? this.columnManagerSqlQuery
            : "") ||
          "",
      ).trim();
    },

    async openAiChat() {
      this.aiChatSessionId = "vizlet_" + Date.now();
      this.aiChatMessages = [];
      this.aiChatInput = "";
      this.aiChatError = null;
      this.aiChatLoading = false;
      this.aiChatScreenshot = null;

      await this.captureVizletScreenshot();
      this.$refs["ai-chat-modal"].show();
      this.$nextTick(() => this.sendInitialAiPrompt());
    },

    async captureVizletScreenshot() {
      try {
        const card = this.$el.closest(".card");
        if (!card) return;
        const canvas = await html2canvas(card, {
          useCORS: true,
          allowTaint: true,
          scale: 1,
          logging: false,
          backgroundColor: "#ffffff",
        });
        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/png")
        );
        if (blob) {
          this.aiChatScreenshot = new File(
            [blob],
            "vizlet-screenshot.png",
            { type: "image/png" }
          );
        }
      } catch (e) {
        console.warn("Screenshot capture failed, proceeding without it", e);
      }
    },

    buildVizDataFile() {
      try {
        const raw = this.vizData;
        if (!raw) return null;
        const rows = Array.isArray(raw) ? raw : [raw];
        if (rows.length === 0) return null;

        const MAX_ROWS = 200;
        const sample = rows.length > MAX_ROWS ? rows.slice(0, MAX_ROWS) : rows;
        const payload = {
          totalRows: rows.length,
          sampleRows: sample.length,
          data: sample,
        };
        const json = JSON.stringify(payload, null, 2);
        return new File([json], "vizlet-data.json", {
          type: "application/json",
        });
      } catch (e) {
        console.warn("Failed to build viz data file", e);
        return null;
      }
    },

    async sendInitialAiPrompt() {
      const title = this.viz1.vizletTitleDpName || "this visualization";
      const hasImage = !!this.aiChatScreenshot;
      const hasData = !!this.vizData;
      const prompt =
        `You are looking at a dashboard visualization titled "${title}".` +
        (hasImage
          ? ` A screenshot of the current dashboard view is attached — use it to understand the layout, charts, data points, and metrics visible on screen.`
          : "") +
        (hasData
          ? ` The underlying JSON data for this visualization is also attached as a file — use it for accurate analysis of the actual values, trends, and outliers.`
          : "") +
        ` Please provide: 1) A concise summary of what this visualization or report represents, ` +
        `2) The key metrics or data points available on this screen, and ` +
        `3) Three specific actionable insights or recommendations a business user should consider. ` +
        `Format your response clearly with numbered sections. Keep the output short and precise.`;
      await this.sendAiMessage(prompt, true);
    },

    async sendAiChat() {
      const text = this.aiChatInput.trim();
      if (!text || this.aiChatLoading) return;
      this.aiChatInput = "";
      await this.sendAiMessage(text, false);
    },

    async sendAiMessage(text, isSystem) {
      if (!isSystem) {
        this.aiChatMessages.push({ role: "user", content: text });
      }
      this.$nextTick(this.scrollAiChat);

      this.aiChatLoading = true;
      this.aiChatError = null;

      try {
        const form = new FormData();
        form.append("session_id", this.aiChatSessionId);
        form.append(
          "system_prompt",
          "You are a helpful AI assistant, answer relevant to the data provided. Do not use generate_viz_config_sql tool"
        );
        form.append("user_text", text);
        form.append("tools_hint", JSON.stringify([]));
        form.append("max_tokens", "4096");

        if (isSystem && this.aiChatScreenshot) {
          form.append("images", this.aiChatScreenshot);
        }

        if (isSystem && this.vizData) {
          const jsonBlob = this.buildVizDataFile();
          if (jsonBlob) {
            form.append("files", jsonBlob);
          }
        }

        const res = await axios.post("/api/chat", form, {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 620000,
        });

        const data = res.data;
        const responseText = this.extractAiResponseText(data);
        this.aiChatMessages.push({
          role: "assistant",
          content: responseText || "No response was returned.",
        });
      } catch (err) {
        console.error("AI chat error", err);
        this.aiChatError =
          (err.response && err.response.data && err.response.data.message) ||
          "Failed to get AI response. Please try again.";
      } finally {
        this.aiChatLoading = false;
        this.$nextTick(this.scrollAiChat);
      }
    },

    extractAiResponseText(data) {
      const raw =
        (data && data.response && data.response.text) || data.response || "";
      if (!raw) return "";
      if (typeof raw === "string") {
        const trimmed = raw.trim();
        if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
          try {
            const json = trimmed
              .replace(/'/g, '"')
              .replace(/True/g, "true")
              .replace(/False/g, "false")
              .replace(/None/g, "null");
            const parsed = JSON.parse(json);
            if (Array.isArray(parsed)) {
              return parsed
                .filter((b) => !b.type || b.type === "text")
                .map((b) => (typeof b === "string" ? b : b.text || ""))
                .join("\n")
                .trim();
            }
            if (parsed && parsed.text) return parsed.text;
          } catch (e) {
            // not JSON, return as-is
          }
        }
        return raw;
      }
      if (Array.isArray(raw)) {
        return raw
          .filter((b) => !b.type || b.type === "text")
          .map((b) => (typeof b === "string" ? b : b.text || ""))
          .join("\n")
          .trim();
      }
      if (typeof raw === "object" && raw.text) return raw.text;
      return String(raw);
    },

    formatAiText(text) {
      if (!text) return "";
      let s = String(text)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
      s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
      s = s.replace(
        /`([^`]+)`/g,
        '<code style="background:#f3f4f6;border-radius:3px;padding:1px 5px;font-family:monospace;font-size:13px;">$1</code>'
      );
      s = s.replace(/\n/g, "<br />");
      return s;
    },

    scrollAiChat() {
      const el = this.$refs.aiChatMessages;
      if (el) el.scrollTop = el.scrollHeight;
    },

    onAiChatHidden() {
      if (this.aiChatScreenshot) {
        URL.revokeObjectURL(this.screenshotPreviewUrl);
      }
      this.aiChatMessages = [];
      this.aiChatInput = "";
      this.aiChatError = null;
      this.aiChatLoading = false;
      this.aiChatSessionId = null;
      this.aiChatScreenshot = null;
    },

    showTooltip() {
      const tooltip = this.$refs.tooltipIcon && this.$refs.tooltipIcon._tooltip;
      if (tooltip && tooltip.show) tooltip.show();
    },
    hideTooltip() {
      const tooltip = this.$refs.tooltipIcon && this.$refs.tooltipIcon._tooltip;
      if (tooltip && tooltip.hide) tooltip.hide();
    },
    handleSearchInput() {
      const q = this.localSearchQuery;
      this.$emit("search", q);
      this.$emit("update:searchQuery", q);
    },

    getColumnLabel(key) {
      if (!key || typeof key !== "string") return key;
      // Strip trailing '#' and optional _name for display only
      return key.replace(/#$/, "").replace(/_name$/, "");
    },

    /** allHeaderMap / allHeaderColumnDp entry: string legacy or { aliasKey, actualKey } */
    resolveAliasKey(meta) {
      if (meta == null) return "";
      if (typeof meta === "string") return meta;
      if (typeof meta === "object" && typeof meta.aliasKey === "string")
        return meta.aliasKey;
      return "";
    },

    resolveActualKey(meta) {
      if (meta == null) return "";
      if (typeof meta === "object" && meta.actualKey != null)
        return String(meta.actualKey);
      return "";
    },

    /**
     * Key used in headerMap / chips for this catalog row (allHeaderMap key may differ, e.g. Salesman vs Salesmperson).
     */
    findHeaderDisplayKeyForCatalogRow(
      headerMap,
      catalogBase,
      aliasKey,
      isMetricColumn,
      metricAlias,
      graphAlias,
    ) {
      if (!headerMap || typeof headerMap !== "object") return null;
      if (
        Object.prototype.hasOwnProperty.call(headerMap, catalogBase) &&
        headerMap[catalogBase]
      ) {
        return catalogBase;
      }
      const matchVals = new Set();
      if (aliasKey) matchVals.add(aliasKey);
      if (isMetricColumn) {
        if (metricAlias) matchVals.add(metricAlias);
        if (graphAlias) matchVals.add(graphAlias);
      }
      for (const dk of Object.keys(headerMap)) {
        const v = headerMap[dk];
        if (v != null && v !== "" && matchVals.has(v)) return dk;
      }
      return null;
    },

    visibleColumnIndexForCatalogCol(visibleColumns, catalogCol) {
      if (!Array.isArray(visibleColumns) || !catalogCol) return -1;
      const aliasKey = catalogCol.alias;
      const catalogBase = catalogCol.base;
      const displayKey = catalogCol.headerDisplayKey;
      return visibleColumns.findIndex((c) => {
        if (!c) return false;
        const cb = this.visibleColumnBaseKey(c);
        const ca = c.alias;
        if (catalogBase && cb === catalogBase) return true;
        if (displayKey && cb === displayKey) return true;
        if (aliasKey != null && aliasKey !== "" && ca === aliasKey) return true;
        return false;
      });
    },

    normalizeChipBaseValue(rawValue) {
      if (rawValue == null) return "";
      if (typeof rawValue === "object") {
        if (Object.prototype.hasOwnProperty.call(rawValue, "base")) {
          return this.normalizeChipBaseValue(rawValue.base);
        }
        return "";
      }
      if (typeof rawValue === "string") {
        const trimmed = rawValue.trim();
        if (trimmed.startsWith("{") && trimmed.includes("\"base\"")) {
          try {
            const parsed = JSON.parse(trimmed);
            if (parsed && typeof parsed === "object") {
              const nested = this.normalizeChipBaseValue(parsed.base);
              if (nested) return nested;
            }
          } catch (_) {
            // keep raw string when not valid JSON
          }
        }
        return rawValue;
      }
      return String(rawValue);
    },

    visibleColumnBaseKey(col) {
      const rawBase = col && typeof col === "object" ? col.base : col;
      return this.normalizeChipBaseValue(rawBase);
    },

    visibleColumnChipLabel(col) {
      const label = this.visibleColumnBaseKey(col);
      return label || "";
    },

    /** Physical column id for formulas (e.g. m1003); optional on header map entries */
    resolveDbColumn(meta) {
      if (meta == null) return "";
      if (typeof meta === "object" && meta.dbColumn != null) {
        const s = String(meta.dbColumn).trim();
        return s || "";
      }
      return "";
    },

    fullAllHeaderMapRef() {
      return (
        this.allHeaderMap ||
        (this.viz1 && this.viz1.allHeaderColumnDp) ||
        {}
      );
    },

    getActualKeyForBase(base) {
      if (base == null || base === "") return "";
      const meta = this.fullAllHeaderMapRef()[base];
      return this.resolveActualKey(meta);
    },

    columnCheckboxDisplayLabel(col) {
      if (!col) return "";
      const ak = col.actualKey || this.getActualKeyForBase(col.base);
      if (ak) return `${col.base} (${ak})`;
      return col.base;
    },

    columnCheckboxActualKey(col) {
      if (!col) return "";
      const ak = col.actualKey || this.getActualKeyForBase(col.base);
      return ak ? String(ak) : "";
    },

    columnListTooltip(col) {
      if (!col) return undefined;
      const ak = col.actualKey || this.getActualKeyForBase(col.base);
      if (col.isRenamed && col.headerDisplayKey) {
        const bits = [];
        if (ak) bits.push(`Key: ${ak}`);
        bits.push(`Header label: “${col.headerDisplayKey}”`);
        return bits.join(" · ");
      }
      return ak || undefined;
    },

    /** Tooltip on draggable chip input only: shows actualKey when known */
    visibleColumnInputTooltip(col) {
      if (!col || typeof col !== "object") return undefined;
      const ak = this.getActualKeyForBase(col.base);
      return ak || undefined;
    },

    isEditingColumnChip(col, idx) {
      return this.editingColumnChipKey === this.columnChipKey(col, idx);
    },

    isInlineBaseInputEditable(col) {
      if (!col || typeof col !== "object") return false;
      if (!this.isInlineBaseEditSupported(col)) return false;
      return typeof col.base === "string" || typeof col.base === "number";
    },

    isInlineBaseEditSupported(col) {
      if (!col || typeof col !== "object") return false;
      return !this.isUserEditableDerivedColumn(col);
    },

    columnChipInputRefName(col, idx) {
      return "chip-base-input-" + this.columnChipKey(col, idx);
    },

    toggleColumnChipInlineEdit(col, idx) {
      if (!this.isInlineBaseEditSupported(col)) return;
      const key = this.columnChipKey(col, idx);
      this.editingColumnChipKey =
        this.editingColumnChipKey === key ? null : key;
      if (this.editingColumnChipKey) {
        this.$nextTick(() => {
          const refName = this.columnChipInputRefName(col, idx);
          const refValue = this.$refs[refName];
          const active = Array.isArray(refValue) ? refValue[0] : refValue;
          if (active && typeof active.focus === "function") {
            active.focus();
            const len = typeof active.value === "string" ? active.value.length : 0;
            if (typeof active.setSelectionRange === "function") {
              active.setSelectionRange(len, len);
            }
          }
        });
      }
    },

    stopColumnChipInlineEdit() {
      this.editingColumnChipKey = null;
      if (typeof document !== "undefined" && document.activeElement) {
        const active = document.activeElement;
        if (
          active &&
          active.classList &&
          active.classList.contains("chip-base-input") &&
          typeof active.blur === "function"
        ) {
          active.blur();
        }
      }
    },

    columnChipKey(col, idx) {
      if (!col) return "v-" + idx;
      const id =
        typeof col === "object"
          ? (col.alias != null ? col.alias : this.visibleColumnBaseKey(col))
          : col;
      return "v-" + (id || idx);
    },

    isNewLayoutColumn(base) {
      const a = this.reportHeaderNewColumnTitles;
      return (
        Array.isArray(a) &&
        base != null &&
        base !== "" &&
        a.indexOf(base) >= 0
      );
    },

    async openColumnManager() {
      this.columnManagerFetchError = null;
      this.columnManagerFetchErrorQuery = null;
      this.columnManagerMappingError = null;
      this.editingColumnChipKey = null;
      const headerMap = this.lastSavedHeaderMap || this.currentHeaderMap;
      this.originalHeaderMap = { ...headerMap };
      if (!this.defaultHeaderMap) {
        this.defaultHeaderMap = { ...headerMap };
      }
      const existingDerived =
        (this.viz1 && (this.viz1.derivedColumn || this.viz1.derived_column)) ||
        {};
      this.derivedColumnLocal = { ...(existingDerived || {}) };

      this.visibleColumns = chipsFromReportHeaderMap(headerMap);

      const mode = normalizeDataSourceMode(
        this.viz1?.vizParamJson ?? this.viz1?.viz_param_json,
      );
      this.resolvedDataSourceMode = mode;
      this.useLegacyColumnList = !mode;
      this.vizletMappingRows = [];
      this.columnManagerMappingSearch = "";

      if (mode) {
        this.columnManagerCatalogLoading = true;
        try {
          const hasSqlDraft =
            mode === "sql" && String(this.columnManagerSqlDraft || "").trim();
          const rawDatasql = hasSqlDraft
            ? this.columnManagerSqlDraft
            : this.viz1?.datasql || "";
          const aliasedRaw =
            mode === "sql" && String(this.columnManagerAliasedSqlDraft || "").trim()
              ? this.columnManagerAliasedSqlDraft
              : this.viz1?.tableBarSql || this.viz1?.datasql || "";
          const datasql =
            mode === "sql"
              ? hasSqlDraft
                ? rawDatasql
                : stripSelectAliasesFromSql(rawDatasql)
              : rawDatasql;
          if (mode === "sql") {
            this.columnManagerSqlQuery = datasql;
            this.columnManagerSqlParseError = null;
          }
          const allHeaderMap =
            this.allHeaderMap || this.viz1?.allHeaderColumnDp || {};
          const draftRows = Array.isArray(this.columnManagerMappingRowsDraft)
            ? this.columnManagerMappingRowsDraft
            : [];
          const result = await loadVariableMappingRows({
            dataSourceMode: mode,
            datasql,
            aliasedDatasql: mode === "sql" ? aliasedRaw : "",
            headerMap,
            allHeaderMap,
            existingSqlRows: mode === "sql" ? draftRows : [],
            includeShowColumn: true,
            visibleColumns: this.visibleColumns,
            showAllCatalogColumns: mode === "table",
          });
          this.resolvedDataSourceMode = result.mode;
          this.vizletMappingRows = result.rows || [];
          this.columnManagerMappingError = result.catalogError;
          if (!this.vizletMappingRows.length) {
            this.useLegacyColumnList = true;
            this.buildLegacyColumnSelection(headerMap);
          } else {
            this.columnSelection = syncSelectionFromMapping(
              this.vizletMappingRows,
              mode,
              headerMap,
            );
            if (mode === "table") {
              this.attachCatalogKeysToVisibleChips();
              this.pruneOrphanMappingChips();
              this.refreshTableModeChartAliases();
            }
          }
        } catch (e) {
          console.warn("column mapping load failed", e);
          this.columnManagerMappingError =
            "Could not load column mapping. Using legacy list.";
          this.useLegacyColumnList = true;
          this.buildLegacyColumnSelection(headerMap);
        } finally {
          this.columnManagerCatalogLoading = false;
        }
      } else {
        this.columnManagerMappingError =
          "Missing vizParamJson.dataSourceMode (SQL or Table).";
        this.buildLegacyColumnSelection(headerMap);
      }

      this.$refs["col-manager-modal"].show();
    },

    buildLegacyColumnSelection(headerMap) {
      const allHeaderMap =
        this.allHeaderMap || this.viz1?.allHeaderColumnDp || {};
      const allKeys = Object.keys(allHeaderMap);

      this.columnSelection = allKeys.map((key) => {
        const base = key;
        const rawMeta = allHeaderMap[key];
        const aliasKey = this.resolveAliasKey(rawMeta);
        const actualKey = this.resolveActualKey(rawMeta) || null;

        let metricAlias = aliasKey;
        let graphAlias = null;
        let isMetricColumn = false;

        if (typeof aliasKey === "string" && aliasKey) {
          const lower = aliasKey.toLowerCase();
          if (lower.startsWith("metric")) {
            graphAlias = "graph" + aliasKey.slice("metric".length);
            isMetricColumn = true;
          } else if (lower.startsWith("graph")) {
            graphAlias = aliasKey;
            metricAlias = "metric" + aliasKey.slice("graph".length);
            isMetricColumn = true;
          } else {
            metricAlias = null;
            graphAlias = null;
          }
        }

        const headerDisplayKey = this.findHeaderDisplayKeyForCatalogRow(
          headerMap,
          base,
          aliasKey,
          isMetricColumn,
          metricAlias,
          graphAlias,
        );
        const isCurrentlyVisible =
          headerDisplayKey != null && !!headerMap[headerDisplayKey];
        const currentAlias = headerDisplayKey
          ? headerMap[headerDisplayKey]
          : headerMap[key];
        const isRenamed =
          isCurrentlyVisible && String(headerDisplayKey) !== String(base);

        let colMode = null;
        if (isMetricColumn && isCurrentlyVisible) {
          colMode =
            typeof currentAlias === "string" &&
            currentAlias.toLowerCase().startsWith("graph")
              ? "graph"
              : "metric";
        } else if (!isMetricColumn) {
          colMode = "metric";
        }

        return {
          base,
          alias: aliasKey,
          actualKey,
          metricAlias,
          graphAlias,
          isMetricColumn,
          headerDisplayKey,
          isRenamed,
          mode: colMode,
          modeSelected: isCurrentlyVisible && isMetricColumn,
          checked: isCurrentlyVisible,
        };
      });
    },

    findVizletMappingRowIndex(row) {
      if (!row) return -1;
      const rows = this.vizletMappingRows || [];
      if (this.resolvedDataSourceMode === "table") {
        return rows.findIndex((r) => r && r.columnName === row.columnName);
      }
      return rows.findIndex(
        (r) => r && r.required === row.required && r.expr === row.expr,
      );
    },

    patchVizletMappingRow(row, patch) {
      const idx = this.findVizletMappingRowIndex(row);
      if (idx < 0) return;
      const next = { ...this.vizletMappingRows[idx], ...patch };
      this.$set(this.vizletMappingRows, idx, next);
      return next;
    },

    findVisibleColumnIndexByDisplayName(displayName) {
      const key = String(displayName || "")
        .trim()
        .toLowerCase();
      if (!key) return -1;
      return this.visibleColumns.findIndex(
        (c) =>
          c &&
          String(c.base || "")
            .trim()
            .toLowerCase() === key,
      );
    },

    findVisibleColumnIndexByCatalogKey(columnName) {
      const key = String(columnName || "")
        .trim()
        .toLowerCase();
      if (!key) return -1;
      return (this.visibleColumns || []).findIndex((c) => {
        if (!c) return false;
        if (
          c.catalogKey != null &&
          String(c.catalogKey).trim().toLowerCase() === key
        ) {
          return true;
        }
        return false;
      });
    },

    /** Stable mapping row ↔ chip link (catalog column, not display label). */
    findVisibleColumnIndexForMappingRow(row) {
      if (!row) return -1;
      if (this.resolvedDataSourceMode === "table" && row.columnName) {
        const byCatalog = this.findVisibleColumnIndexByCatalogKey(row.columnName);
        if (byCatalog !== -1) return byCatalog;
      }
      const displayKey =
        this.resolvedDataSourceMode === "table"
          ? row.displayName
          : row.label;
      return this.findVisibleColumnIndexByDisplayName(displayKey);
    },

    mappingChipPayload(row, displayKey, alias) {
      const chip = { base: displayKey, alias };
      if (this.resolvedDataSourceMode === "table" && row.columnName) {
        chip.catalogKey = row.columnName;
      } else if (row._catalogKey || row.expr) {
        chip.catalogKey = row._catalogKey || row.expr;
      }
      return chip;
    },

    attachCatalogKeysToVisibleChips() {
      (this.visibleColumns || []).forEach((chip, idx) => {
        if (!chip || chip.catalogKey) return;
        const baseNorm = String(chip.base || "")
          .trim()
          .toLowerCase();
        const aliasNorm = String(chip.alias || "").trim();
        const row = (this.vizletMappingRows || []).find((r) => {
          if (!r) return false;
          const disp = String(r.displayName || "")
            .trim()
            .toLowerCase();
          if (disp && disp === baseNorm) return true;
          if (
            aliasNorm &&
            r._chartAlias &&
            String(r._chartAlias).trim() === aliasNorm
          ) {
            return true;
          }
          return (
            String(r.columnName || "")
              .trim()
              .toLowerCase() === baseNorm
          );
        });
        if (row && row.columnName) {
          this.$set(this.visibleColumns, idx, {
            ...chip,
            catalogKey: row.columnName,
          });
        }
      });
    },

    getIncludedMappingRowsInChipOrder() {
      const rowByCatalog = new Map();
      const rowByDisplay = new Map();
      (this.vizletMappingRows || []).forEach((row) => {
        if (!row) return;
        if (row.columnName) {
          rowByCatalog.set(String(row.columnName).trim().toLowerCase(), row);
        }
        const labelKey = String(row.displayName || row.label || "")
          .trim()
          .toLowerCase();
        if (labelKey) rowByDisplay.set(labelKey, row);
      });
      const ordered = [];
      (this.visibleColumns || []).forEach((chip) => {
        if (!chip) return;
        let row = null;
        const catalog = String(chip.catalogKey || "")
          .trim()
          .toLowerCase();
        if (catalog) row = rowByCatalog.get(catalog);
        if (!row) {
          const key = String(chip.base || "")
            .trim()
            .toLowerCase();
          row = rowByDisplay.get(key);
        }
        if (row && row.include) ordered.push(row);
      });
      return ordered;
    },

    refreshTableModeChartAliases() {
      if (this.resolvedDataSourceMode !== "table") return;
      const headerMap =
        this.originalHeaderMap || this.currentHeaderMap || {};
      const mergedDerived = {
        ...(this.viz1?.derivedColumn || this.viz1?.derived_column || {}),
        ...(this.derivedColumnLocal || {}),
      };
      const built = buildVizletTableBarColumnLayout({
        mappingRows: this.vizletMappingRows,
        visibleColumns: this.visibleColumns,
        existingHeaderMap: headerMap,
        datasql: this.viz1?.datasql || "",
        derivedColumn: mergedDerived,
      });
      const aliasByLabel = built.headerMap || {};
      (this.visibleColumns || []).forEach((chip, idx) => {
        const label = String(chip.base || "").trim();
        let alias = aliasByLabel[label];
        if (headerMapHasGraphCompanion(aliasByLabel, label)) {
          alias = aliasByLabel[`${label}#`] || alias;
        }
        if (alias) {
          this.$set(this.visibleColumns, idx, { ...chip, alias });
        }
      });
      const ordered = this.getIncludedMappingRowsInChipOrder();
      const withA = assignChartAliasesToRows(ordered, headerMap);
      withA.forEach((row) => {
        const idx = this.findVizletMappingRowIndex(row);
        if (idx >= 0) {
          this.$set(this.vizletMappingRows, idx, {
            ...this.vizletMappingRows[idx],
            _chartAlias: row._chartAlias,
          });
        }
      });
      this.tableBarSqlLocal = built.tableBarSql || "";
    },

    resolveMappingRowAlias(row) {
      const allHeaderMap =
        this.allHeaderMap || this.viz1?.allHeaderColumnDp || {};
      if (this.resolvedDataSourceMode === "table") {
        return (
          row._chartAlias ||
          row._aliasKey ||
          this.resolveAliasKey(allHeaderMap[row.columnName]) ||
          row.columnName
        );
      }
      return (
        row._aliasKey ||
        this.resolveAliasKey(allHeaderMap[row._catalogKey]) ||
        row._aliasKey ||
        ""
      );
    },

    pruneGraphCompanionChips() {
      this.visibleColumns = (this.visibleColumns || []).filter((c) => {
        const base = this.visibleColumnBaseKey(c);
        return base && !String(base).endsWith("#");
      });
    },

    resolveMappingRowChipAlias(row) {
      const isMetric =
        row &&
        (row._isMetricColumn ||
          String(row.displayType || row.type || "")
            .trim()
            .toLowerCase() === "metric");
      const wantsGraph =
        isMetric &&
        String(row.graph || "")
          .trim()
          .toLowerCase()
          .startsWith("y");
      if (wantsGraph) {
        if (row._graphAlias) return row._graphAlias;
        const metricAlias = row._metricAlias || row._aliasKey || row._chartAlias || "";
        const m = /^metric(\d+)$/i.exec(String(metricAlias).trim());
        if (m) return `graph${m[1]}`;
      }
      return this.resolveMappingRowAlias(row);
    },

    applyColumnSelectionFromMapping() {
      const headerMap = this.originalHeaderMap || this.currentHeaderMap || {};
      const mode = this.resolvedDataSourceMode;

      if (mode === "table") {
        for (const row of this.vizletMappingRows || []) {
          if (!row) continue;
          const displayKey = String(row.displayName || "").trim();
          const chipIdx = this.findVisibleColumnIndexForMappingRow(row);
          if (row.include) {
            const alias = this.resolveMappingRowChipAlias(row);
            const chip = this.mappingChipPayload(row, displayKey, alias);
            if (chipIdx === -1) {
              this.visibleColumns.push(chip);
            } else {
              this.$set(this.visibleColumns, chipIdx, {
                ...this.visibleColumns[chipIdx],
                ...chip,
              });
            }
          } else if (chipIdx !== -1) {
            this.visibleColumns.splice(chipIdx, 1);
          }
        }
        this.pruneOrphanMappingChips();
        this.refreshTableModeChartAliases();
        this.pruneGraphCompanionChips();
      } else if (mode === "sql") {
        for (const row of this.vizletMappingRows || []) {
          if (!row) continue;
          const displayKey = String(row.label || "").trim();
          const shown = !!row.show;
          const chipIdx = this.findVisibleColumnIndexByDisplayName(displayKey);
          if (shown) {
            const alias = this.resolveMappingRowChipAlias(row);
            const chip = this.mappingChipPayload(row, displayKey, alias);
            if (chipIdx === -1) {
              this.visibleColumns.push(chip);
            } else {
              this.$set(this.visibleColumns, chipIdx, {
                ...this.visibleColumns[chipIdx],
                ...chip,
              });
            }
          } else if (chipIdx !== -1) {
            this.visibleColumns.splice(chipIdx, 1);
          }
        }
        const activeLabels = new Set(
          (this.vizletMappingRows || [])
            .filter((r) => r && r.show)
            .map((r) =>
              String(r.label || "")
                .trim()
                .toLowerCase(),
            )
            .filter(Boolean),
        );
        this.visibleColumns = (this.visibleColumns || []).filter((c) => {
          const base = String(this.visibleColumnBaseKey(c) || "")
            .trim()
            .toLowerCase();
          return base && activeLabels.has(base);
        });
        this.pruneGraphCompanionChips();
      }

      this.columnSelection = syncSelectionFromMapping(
        this.vizletMappingRows,
        mode,
        headerMap,
      );
      if (mode === "table") {
        this.refreshTableModeChartAliases();
      }
    },

    /**
     * Remove chips left over from in-progress display-name edits (matched by label, not catalog).
     */
    pruneOrphanMappingChips() {
      if (this.resolvedDataSourceMode !== "table") return;
      const includedCatalog = new Set(
        (this.vizletMappingRows || [])
          .filter((r) => r && r.include && r.columnName)
          .map((r) => String(r.columnName).trim().toLowerCase()),
      );
      const includedLabels = new Set(
        (this.vizletMappingRows || [])
          .filter((r) => r && r.include)
          .map((r) => String(r.displayName || "").trim().toLowerCase())
          .filter(Boolean),
      );
      this.visibleColumns = (this.visibleColumns || []).filter((chip) => {
        if (!chip) return false;
        const catalog = String(chip.catalogKey || "")
          .trim()
          .toLowerCase();
        if (catalog) return includedCatalog.has(catalog);
        const base = String(chip.base || "")
          .trim()
          .toLowerCase();
        if (/^metric\d+$/i.test(String(chip.alias || ""))) return true;
        return includedLabels.has(base);
      });
    },

    onVizletMappingRowChange({ row, field, value, rowPatch }) {
      const prevLabel =
        row && row.label != null ? String(row.label) : "";
      const patch = rowPatch ? { ...rowPatch, [field]: value } : { [field]: value };
      const updated = this.patchVizletMappingRow(row, patch);
      if (!updated) return;
      if (
        this.resolvedDataSourceMode === "sql" &&
        field === "label" &&
        prevLabel
      ) {
        const chipIdx = this.findVisibleColumnIndexByDisplayName(prevLabel);
        if (chipIdx !== -1) {
          this.$set(this.visibleColumns[chipIdx], "base", value);
        }
      }
      this.applyColumnSelectionFromMapping();
    },

    /** Auto-sync mapping rows while user edits SQL (same pattern as menu-config dataSqlId watcher). */
    syncColumnManagerSqlFromQuery(sql) {
      const trimmed = String(sql || "").trim();
      if (!trimmed) {
        this.vizletMappingRows = [];
        this.columnManagerSqlParseError = null;
        return;
      }
      const headerMap = this.lastSavedHeaderMap || this.currentHeaderMap || {};
      const rows = syncSqlModeMappingRowsFromSql({
        sql: trimmed,
        headerMap,
        visibleColumns: this.visibleColumns,
        existingRows: this.vizletMappingRows,
        aliasedDatasql:
          String(this.columnManagerAliasedSqlDraft || "").trim() ||
          this.viz1?.tableBarSql ||
          this.viz1?.datasql ||
          "",
      });
      if (!rows.length) {
        this.columnManagerSqlParseError =
          "Could not parse columns from SQL. Check the SELECT list.";
        return;
      }
      this.columnManagerSqlParseError = null;
      this.vizletMappingRows = rows;
      this.applyColumnSelectionFromMapping();
    },

    onVizletSetAllInclude(include) {
      const rows = this.vizletMappingRows || [];
      rows.forEach((row, idx) => {
        if (row) this.$set(this.vizletMappingRows, idx, { ...row, include: !!include });
      });
      this.applyColumnSelectionFromMapping();
    },

    onDragEnd() {
      /* order updated via v-model */
    },

    onDragStart() {
      // Keep drag interaction clean: close any inline edit state before moving chips.
      this.stopColumnChipInlineEdit();
    },

    /** Display type only for checked metric columns not yet in the chip list */
    isMetricToggleColumn(col) {
      if (!col?.checked || !col.isMetricColumn) return false;
      const id = col.base || col;
      if (!id) return false;
      return this.visibleColumnIndexForCatalogCol(this.visibleColumns, col) === -1;
    },

    removeColumn(col) {
      const chipKey = this.visibleColumnBaseKey(col);
      if (!chipKey) return;

      this.visibleColumns = this.visibleColumns.filter((c) => {
        const cid = this.visibleColumnBaseKey(c);
        return cid !== chipKey;
      });

      if (
        this.resolvedDataSourceMode &&
        !this.useLegacyColumnList &&
        Array.isArray(this.vizletMappingRows)
      ) {
        const chipNorm = String(chipKey).trim().toLowerCase();
        const chipCatalog =
          col && col.catalogKey != null
            ? String(col.catalogKey).trim().toLowerCase()
            : "";
        this.vizletMappingRows.forEach((row, idx) => {
          if (!row) return;
          const catalogMatch =
            this.resolvedDataSourceMode === "table" &&
            chipCatalog &&
            row.columnName &&
            String(row.columnName).trim().toLowerCase() === chipCatalog;
          const name =
            this.resolvedDataSourceMode === "table"
              ? row.displayName
              : row.label;
          const labelMatch =
            String(name || "")
              .trim()
              .toLowerCase() === chipNorm;
          if (catalogMatch || labelMatch) {
            const patch =
              this.resolvedDataSourceMode === "table"
                ? { include: false }
                : { show: false };
            this.$set(this.vizletMappingRows, idx, { ...row, ...patch });
          }
        });
      }

      const catalogMatch = this.columnSelection.find(
        (c) =>
          c &&
          (c.headerDisplayKey === chipKey ||
            c.base === chipKey ||
            (col.alias != null && c.alias === col.alias)),
      );
      const catalogId = catalogMatch ? catalogMatch.base : chipKey;

      this.columnSelection = this.columnSelection.map((c) => {
        if (!c) return c;
        if (
          c.base === catalogId ||
          c.base === chipKey ||
          c.headerDisplayKey === chipKey
        ) {
          return {
            ...c,
            checked: false,
            ...(c.isMetricColumn ? { mode: null, modeSelected: false } : {}),
          };
        }
        return c;
      });
    },
    addColumn(col, checkedFromEvent) {
      const id = col && (col.base || col);
      if (!id) return;
      // Use event value when available so we react to actual user intent (avoids timing issues with v-model)
      const isChecked = checkedFromEvent !== undefined ? checkedFromEvent : col.checked;
      const alreadyExistsIndex = this.visibleColumnIndexForCatalogCol(
        this.visibleColumns,
        col,
      );

      // If unchecked, remove from visibleColumns and reset metric display choice so re-add has no default
      if (!isChecked) {
        if (alreadyExistsIndex !== -1) {
          this.visibleColumns.splice(alreadyExistsIndex, 1);
        }
        if (col.isMetricColumn) {
          this.columnSelection = this.columnSelection.map((c) =>
            c && (c.base || c) === id
              ? { ...c, checked: false, mode: null, modeSelected: false }
              : c,
          );
        }
        return;
      }

      // Metric columns: wait for explicit display-type choice before adding
      if (col.isMetricColumn) {
        // Just ensure checkbox state is tracked; onMetricModeChange will add/update visibleColumns
        return;
      }

      // Non-metric: chip key is catalog base unless user renamed it in headerMap (use that display key)
      const displayKey = col.headerDisplayKey || String(id);
      if (alreadyExistsIndex === -1) {
        this.visibleColumns.push({
          base: displayKey,
          alias: col.alias,
        });
      }
      console.log('this.visibleColumns', this.visibleColumns);
      // When already present and checked, leave it in place (do not remove)
    },

    onMetricModeChange(col) {
      const id = col && (col.base || col);
      if (!id || !col.checked || !col.isMetricColumn) return;
      col.modeSelected = true;

      const alias =
        col.mode === "graph" && col.graphAlias
          ? col.graphAlias
          : col.metricAlias || col.alias;
      if (!alias) return;

      const displayKey = col.headerDisplayKey || String(id);
      const idx = this.visibleColumnIndexForCatalogCol(this.visibleColumns, col);
      if (idx === -1) {
        this.visibleColumns.push({
          base: displayKey,
          alias,
        });
      } else {
        this.visibleColumns[idx] = {
          ...this.visibleColumns[idx],
          base: displayKey,
          alias,
        };
      }
    },

    clearColumnManagerDraft() {
      this.columnManagerSqlDraft = "";
      this.columnManagerMappingRowsDraft = null;
      this.columnManagerAliasedSqlDraft = "";
    },

    persistColumnManagerDraft({ datasqlToSave, tableBarSql } = {}) {
      if (this.resolvedDataSourceMode !== "sql") return;
      const sql = (this.columnManagerSqlQuery || "").trim();
      if (sql) {
        this.columnManagerSqlDraft = sql;
      }
      this.columnManagerMappingRowsDraft = (this.vizletMappingRows || []).map(
        (row) => ({ ...row }),
      );
      const aliased =
        (datasqlToSave && String(datasqlToSave).trim()) ||
        (tableBarSql && String(tableBarSql).trim()) ||
        "";
      if (aliased) {
        this.columnManagerAliasedSqlDraft = aliased;
      }
    },

    resetDefaults() {
      this.clearColumnManagerDraft();
      if (this.defaultHeaderMap) {
        const headerMap = this.defaultHeaderMap;
        this.visibleColumns = chipsFromReportHeaderMap(this.defaultHeaderMap);

        this.columnSelection = this.columnSelection.map((col) => {
          const headerDisplayKey = this.findHeaderDisplayKeyForCatalogRow(
            headerMap,
            col.base,
            col.alias,
            col.isMetricColumn,
            col.metricAlias,
            col.graphAlias,
          );
          const isVisible =
            headerDisplayKey != null && !!headerMap[headerDisplayKey];
          const isRenamed =
            isVisible && String(headerDisplayKey) !== String(col.base);
          let mode = col.mode;
          let modeSelected = col.modeSelected;
          if (col.isMetricColumn && isVisible) {
            mode = headerMapHasGraphCompanion(headerMap, headerDisplayKey)
              ? "graph"
              : "metric";
            modeSelected = true;
          } else if (col.isMetricColumn && !isVisible) {
            mode = null;
            modeSelected = false;
          }
          return {
            ...col,
            checked: isVisible,
            headerDisplayKey,
            isRenamed,
            mode,
            modeSelected,
          };
        });
        if (this.resolvedDataSourceMode && !this.useLegacyColumnList) {
          this.reloadVizletMappingRows(headerMap);
        }
      }
    },

    async reloadVizletMappingRows(headerMap) {
      const mode = this.resolvedDataSourceMode;
      if (!mode) return;
      const rawDatasql = this.viz1?.datasql || "";
      const datasql =
        mode === "sql"
          ? (this.columnManagerSqlQuery || "").trim() ||
            stripSelectAliasesFromSql(rawDatasql)
          : rawDatasql;
      const allHeaderMap =
        this.allHeaderMap || this.viz1?.allHeaderColumnDp || {};
      const visibleFromHeader = chipsFromReportHeaderMap(headerMap || {});
      const result = await loadVariableMappingRows({
        dataSourceMode: mode,
        datasql,
        aliasedDatasql: mode === "sql" ? rawDatasql : "",
        headerMap: headerMap || this.defaultHeaderMap || {},
        allHeaderMap,
        existingSqlRows:
          mode === "sql" ? this.vizletMappingRows || [] : [],
        includeShowColumn: true,
        visibleColumns: visibleFromHeader,
        showAllCatalogColumns: mode === "table",
      });
      this.vizletMappingRows = result.rows || [];
      this.columnSelection = syncSelectionFromMapping(
        this.vizletMappingRows,
        mode,
        headerMap || {},
      );
    },

    buildColumnsPayload() {
      for (const col of this.columnSelection || []) {
        if (!col?.checked || !col.isMetricColumn) continue;
        const id = col.base || col;
        if (
          !id ||
          this.visibleColumnIndexForCatalogCol(this.visibleColumns, col) !== -1
        ) {
          continue;
        }
        if (!col.mode) col.mode = "metric";
        this.onMetricModeChange(col);
      }

      const viz = this.viz1 || {};
      const existingDerived =
        viz.derivedColumn || viz.derived_column || {};
      const mergedDerived = {
        ...(existingDerived || {}),
        ...(this.derivedColumnLocal || {}),
      };

      if (this.resolvedDataSourceMode === "table") {
        const oldMap = this.originalHeaderMap || this.currentHeaderMap || {};
        const built = buildVizletTableBarColumnLayout({
          mappingRows: this.vizletMappingRows,
          visibleColumns: this.visibleColumns,
          existingHeaderMap: oldMap,
          datasql: viz.datasql || "",
          derivedColumn: mergedDerived,
        });
        const newMap = built.headerMap || {};
        const derivedColumn = this.pruneDerivedColumnMap(mergedDerived, newMap);
        this.tableBarSqlLocal = built.tableBarSql || "";
        return {
          newMap,
          derivedColumn,
          tableBarSql: built.tableBarSql || "",
          datasqlToSave: built.tableBarSql || "",
          dataSourceMode: "table",
        };
      }

      if (this.resolvedDataSourceMode === "sql") {
        const oldMap = this.originalHeaderMap || this.currentHeaderMap || {};
        const built = buildVizletSqlModeColumnLayout({
          rawSql: (this.columnManagerSqlQuery || "").trim(),
          mappingRows: this.vizletMappingRows,
          visibleColumns: this.visibleColumns,
          existingHeaderMap: oldMap,
          originalDatasql: viz.datasql || "",
        });
        const newMap = built.headerMap || {};
        const derivedColumn = this.pruneDerivedColumnMap(mergedDerived, newMap);
        const productionSql = built.tableBarSql || built.datasqlToSave || "";
        return {
          newMap,
          derivedColumn,
          tableBarSql: productionSql,
          datasqlToSave: built.datasqlToSave || productionSql,
          dataSourceMode: "sql",
        };
      }

      const oldMap = this.originalHeaderMap || this.currentHeaderMap || {};
      const newMap = {};

      this.visibleColumns.forEach((col) => {
        if (!col) return;

        const key = this.visibleColumnBaseKey(col);
        const sel = this.columnSelection.find(
          (c) =>
            c &&
            (c.base === key ||
              c.headerDisplayKey === key ||
              (c.alias != null && c.alias === col.alias)),
        );

        let alias = oldMap[key];

        if (sel && sel.isMetricColumn) {
          if (sel.mode === "graph" && sel.graphAlias) {
            alias = sel.graphAlias;
          } else if (sel.mode === "metric" && sel.metricAlias) {
            alias = sel.metricAlias;
          } else if (sel.alias) {
            alias = sel.alias;
          }
        } else if (col.alias) {
          alias = col.alias;
        }

        if (!alias) return;

        newMap[key] = alias;
      });

      const derivedColumn = this.pruneDerivedColumnMap(mergedDerived, newMap);

      return { newMap, derivedColumn, tableBarSql: "" };
    },

    async saveColumns() {
      if (this.resolvedDataSourceMode === "sql") {
        const sql = (this.columnManagerSqlQuery || "").trim();
        const validation = validateReadOnlySelectSql(sql);
        if (!validation.ok) {
          this.columnManagerSqlParseError = validation.message;
          return;
        }
        try {
          const confirmed = await this.$bvModal.msgBoxConfirm(
            "This is the production DataSQL. Do you want to save?",
            {
              title: "Save production DataSQL",
              okTitle: "Yes, save",
              cancelTitle: "Cancel",
              okVariant: "danger",
              centered: true,
            },
          );
          if (!confirmed) return;
        } catch {
          return;
        }
      }

      const {
        newMap,
        derivedColumn,
        tableBarSql,
        datasqlToSave,
        dataSourceMode,
      } = this.buildColumnsPayload();

      this.lastSavedHeaderMap = { ...newMap };
      this.derivedColumnLocal = { ...derivedColumn };
      this.persistColumnManagerDraft({ datasqlToSave, tableBarSql });
      this.rememberColumnLayoutFetchSql(tableBarSql, datasqlToSave);
      this.columnManagerFetchError = null;
      this.columnManagerFetchErrorQuery = null;

      this.$emit("save-columns", {
        reportHeaderColumnDp: newMap,
        derivedColumn,
        tableBarSql: tableBarSql || datasqlToSave || "",
        datasqlToSave: datasqlToSave || tableBarSql || "",
        dataSourceMode: dataSourceMode || this.resolvedDataSourceMode,
      });
      this.$refs["col-manager-modal"].hide();
    },

    previewColumns(options) {
      const keepColumnManagerOpen =
        options &&
        typeof options === "object" &&
        options.keepColumnManagerOpen === true;
      const ratioValidate =
        options &&
        typeof options === "object" &&
        options.ratioValidate === true;

      const {
        newMap,
        derivedColumn,
        tableBarSql,
        datasqlToSave,
        dataSourceMode,
      } = this.buildColumnsPayload();
      this.lastSavedHeaderMap = { ...newMap };
      this.derivedColumnLocal = { ...derivedColumn };
      this.persistColumnManagerDraft({ datasqlToSave, tableBarSql });
      this.rememberColumnLayoutFetchSql(tableBarSql, datasqlToSave);
      this.columnManagerFetchError = null;
      this.columnManagerFetchErrorQuery = null;

      const payload = {
        reportHeaderColumnDp: newMap,
        derivedColumn,
        tableBarSql: tableBarSql || datasqlToSave || "",
        datasqlToSave: datasqlToSave || "",
        dataSourceMode: dataSourceMode || this.resolvedDataSourceMode,
      };
      if (ratioValidate) payload._ratioValidate = true;
      this.$emit("preview-columns", payload);
      if (!keepColumnManagerOpen) {
        this.$refs["col-manager-modal"].hide();
      }
    },

    cancelColumnManager() {
      this.editingColumnChipKey = null;
      this.$refs["col-manager-modal"].hide();
    },
  },
  beforeDestroy() {
    this.onDrawerDragEnd();
    this.onColManagerResizeEnd();
    this.removeColManagerResizeHandles();
    this.unbindDrawerSurfaceDrag("col-manager");
    this.unbindDrawerSurfaceDrag("ratio");
    window.removeEventListener("resize", this.onDrawerWindowResize);
    this.sideDrawerModalCount = 0;
    document.body.classList.remove("vizlet-header-side-drawer-open");
    document.body.classList.remove("vizlet-header-drawer-dragging");
    document.body.classList.remove("vizlet-header-drawer-resizing");
    forceReleaseSelectionLock();
    this.resetRatioErrorQueryCopied();
  },
};
</script>

<style scoped>
.col-manager-chips {
  flex-shrink: 0;
  max-height: min(40vh, 280px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 6px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fafafa;
  position: relative;
  z-index: 1;
}

.col-manager-chip-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: flex-start;
}

.col-chip {
  display: flex;
  align-items: center;
  background: #f0f0f0;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 4px 8px;
  margin: 0;
  font-size: 13px;
  cursor: grab;
  user-select: none;
}

.chip-label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.column-check-label {
  white-space: normal;
  word-break: break-word;
}

.column-check-renamed-mark {
  display: inline-block;
  margin-left: 0.2rem;
  margin-right: 0.05rem;
  font-size: 0.78em;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #b45309;
  background: linear-gradient(180deg, #fffbeb, #fef3c7);
  border: 1px solid #fbbf24;
  border-radius: 3px;
  padding: 0 0.28rem;
  line-height: 1.35;
  vertical-align: baseline;
}

.column-check-actual-key {
  color: #4b5563;
  font-size: 0.92em;
}

.column-check-catalog-name {
  font-weight: 500;
}

.chip-base-input {
  min-width: 4em;
  max-width: 140px;
  padding: 0 4px;
  font-size: 13px;
  border: 1px solid transparent;
  border-radius: 3px;
  background: transparent;
  color: inherit;
  cursor: default;
}
.chip-base-input[readonly] {
  cursor: grab;
  pointer-events: none;
}
.chip-base-input:hover {
  border-color: transparent;
  background: transparent;
}
.chip-base-input--editing {
  cursor: text;
}
.chip-base-input--editing:hover {
  border-color: #ccc;
  background: #fff;
}
.chip-base-input--editing:focus {
  outline: none !important;
  border-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.col-chip:active {
  cursor: grabbing;
}

.chip-ghost {
  opacity: 0.4;
  background: #cce5ff;
}

.chip-edit {
  margin-left: auto;
  padding: 2px 4px;
  font-size: 11px;
  color: #5e8ef4;
  cursor: pointer;
  opacity: 0.85;
}

.chip-edit:hover {
  opacity: 1;
}

.chip-inline-edit {
  margin-left: auto;
  padding: 2px 4px;
  font-size: 11px;
  color: #6b7280;
  cursor: pointer;
  opacity: 0.9;
}

.chip-inline-edit:hover {
  opacity: 1;
  color: #374151;
}

.chip-remove {
  margin-left: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 15px;
  color: #888;
  line-height: 1;
}
.chip-remove:hover {
  color: #c00;
}

.display-toggle .btn-group.btn-group-toggle > .btn {
  padding: 0 1px;
  font-size: 8px;
  line-height: 1;
}

.col-chip-hidden {
  background: #fff;
  border-style: dashed;
  cursor: pointer;
}

.chip-add {
  margin-left: 6px;
  font-weight: bold;
  font-size: 15px;
  color: #28a745;
  line-height: 1;
}

.vizlet-sql-query-section {
  flex-shrink: 0;
  min-width: 0;
}

.vizlet-sql-query-textarea {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8125rem;
  line-height: 1.4;
  border-radius: 6px;
  resize: vertical;
  min-height: 4.5rem;
}

.vizlet-col-mapping-section {
  min-width: 0;
}

.column-checklist {
  max-height: min(50vh, 420px);
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 6px 10px;
  background: #ffffff;
}

.column-check-item {
  padding: 2px 4px;
  border-radius: 3px;
}

.column-check-item--active {
  background: #eff6ff;
}

/* Formula field: reads as an editable control, not static text */
.vizlet-formula-label {
  gap: 0.25rem;
}

.vizlet-formula-editable-badge {
  font-size: 0.7rem;
  color: #495057 !important;
  border-color: #dee2e6 !important;
  vertical-align: middle;
}

.vizlet-formula-textarea {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8125rem;
  background-color: #fffef8;
  border-color: #ced4da;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.vizlet-formula-textarea:hover {
  border-color: #adb5bd;
}

.vizlet-formula-textarea:focus {
  background-color: #fff;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}

/* Gemini icon button */
.gemini-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 2px;
  padding: 3px;
  border-radius: 4px;
  transition: background-color 0.15s ease, transform 0.15s ease;
  color: #4285F4;
}
.gemini-icon-btn:hover {
  background-color: rgba(66, 133, 244, 0.1);
  transform: scale(1.15);
}

.gemini-svg {
  width: 16px;
  height: 16px;
}

.gemini-modal-icon {
  width: 20px;
  height: 20px;
  color: #4285F4;
}

/* Screenshot preview bar */
.ai-chat-screenshot-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: #f0f4ff;
  border-bottom: 1px solid #dbe4f0;
  flex-shrink: 0;
}

.ai-chat-screenshot-thumb {
  width: 80px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #c7d2e0;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.ai-chat-screenshot-thumb:hover {
  transform: scale(2.5);
  z-index: 10;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.ai-chat-attachment-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  color: #4b5563;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 3px 10px;
}

.ai-chat-attachment-tag.data-tag {
  color: #065f46;
  background: #ecfdf5;
  border-color: #a7f3d0;
}

/* AI Chat Modal */
.ai-chat-body {
  display: flex;
  flex-direction: column;
  height: 60vh;
  min-height: 350px;
}

.ai-chat-messages {
  flex: 1 1 0;
  overflow-y: auto;
  padding: 16px;
  background: #f9fafb;
}

.ai-chat-msg {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
}

.ai-chat-msg.user {
  flex-direction: row-reverse;
}

.ai-chat-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4285F4, #8B5CF6);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ai-chat-avatar.user-avatar {
  background: #10b981;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.ai-chat-bubble {
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 13.5px;
  line-height: 1.65;
}

.ai-chat-msg.assistant .ai-chat-bubble {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 2px 12px 12px 12px;
}

.ai-chat-msg.user .ai-chat-bubble {
  background: #4285F4;
  color: #ffffff;
  border-radius: 12px 2px 12px 12px;
}

.ai-chat-text {
  word-break: break-word;
  white-space: pre-wrap;
}

.ai-chat-error {
  padding: 8px 16px;
  font-size: 13px;
  color: #b91c1c;
  background-color: #fee2e2;
  border-top: 1px solid #fecaca;
  flex-shrink: 0;
}

.ai-chat-input-area {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
  flex-shrink: 0;
}

.ai-chat-input {
  flex: 1;
  resize: none;
  min-height: 38px;
  max-height: 100px;
  padding: 8px 12px;
  border-radius: 20px;
  border: 1px solid #d1d5db;
  font-size: 13.5px;
  outline: none;
  transition: border-color 0.15s ease;
}

.ai-chat-input:focus {
  border-color: #4285F4;
  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.15);
}

.ai-chat-send-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: #4285F4;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.15s ease;
}

.ai-chat-send-btn:hover:not([disabled]) {
  background: #3367D6;
}

.ai-chat-send-btn[disabled] {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Typing indicator */
.ai-typing-indicator {
  display: inline-flex;
  gap: 4px;
  padding: 4px 0;
}

.ai-typing-indicator span {
  width: 7px;
  height: 7px;
  background-color: #6b7280;
  border-radius: 50%;
  animation: ai-typing-bounce 1s infinite ease-in-out;
}

.ai-typing-indicator span:nth-child(2) {
  animation-delay: 0.15s;
}

.ai-typing-indicator span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes ai-typing-bounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  40% {
    transform: translateY(-5px);
    opacity: 1;
  }
}
</style>

<!-- Column manager / ratio modals mount under body — needs global selectors -->
<style>
body.modal-open.vizlet-header-side-drawer-open {
  overflow: auto !important;
  padding-right: 0 !important;
}

.vizlet-header-col-manager-drawer.modal {
  z-index: 1050;
}

.vizlet-header-ratio-drawer.modal {
  z-index: 1060;
}

.vizlet-header-col-manager-drawer.modal,
.vizlet-header-ratio-drawer.modal {
  padding-left: 0 !important;
}

.vizlet-header-side-dialog {
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
  margin: 0 !important;
}

/* Column manager: default width; user can resize (see applyColManagerDrawerLayout) */
.vizlet-header-col-manager-dialog {
  width: min(580px, 94vw) !important;
  max-width: min(580px, 94vw) !important;
  height: auto !important;
  max-height: min(92vh, 900px) !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  position: relative !important;
}

.vizlet-col-manager-layout {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  gap: 0;
  position: relative;
  z-index: 0;
}

.vizlet-col-manager-hint,
.vizlet-col-mapping-intro,
.vizlet-col-manager-footer-hint {
  font-size: 0.8125rem;
  line-height: 1.4;
}

.vizlet-col-mapping-section {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #e2e8f0;
  position: relative;
  clear: both;
}

.vizlet-header-col-manager-dialog--resized .vizlet-header-drawer-content {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}

.vizlet-header-col-manager-dialog--resized .modal-body {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  max-height: none !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.vizlet-header-col-manager-dialog--resized .vizlet-col-manager-layout {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.vizlet-header-col-manager-dialog--resized .vizlet-col-mapping-section {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.vizlet-drawer-resize-corner {
  position: absolute;
  right: 2px;
  bottom: 2px;
  width: 16px;
  height: 16px;
  z-index: 20;
  pointer-events: auto;
  cursor: nwse-resize;
  border-radius: 0 0 4px 0;
  background: linear-gradient(
    135deg,
    transparent 50%,
    #94a3b8 50%,
    #94a3b8 58%,
    transparent 58%
  );
  opacity: 0.85;
}

.vizlet-drawer-resize-corner:hover {
  opacity: 1;
}

.vizlet-drawer-resize-edge {
  position: absolute;
  z-index: 19;
  pointer-events: auto;
  background: transparent;
}

.vizlet-drawer-resize-edge--right {
  top: 48px;
  right: 0;
  width: 6px;
  bottom: 12px;
  cursor: ew-resize;
}

.vizlet-drawer-resize-edge--bottom {
  left: 0;
  right: 12px;
  bottom: 0;
  height: 6px;
  cursor: ns-resize;
}

body.vizlet-header-drawer-resizing {
  user-select: none !important;
}

body.vizlet-header-drawer-resizing .fw-copyable-text,
body.vizlet-header-drawer-resizing .fw-copyable-text *,
body.vizlet-header-drawer-dragging .fw-copyable-text,
body.vizlet-header-drawer-dragging .fw-copyable-text *,
body.fw-selection-locked .fw-copyable-text,
body.fw-selection-locked .fw-copyable-text * {
  user-select: text !important;
  -webkit-user-select: text !important;
  cursor: text;
}

body.fw-selection-locked input,
body.fw-selection-locked textarea,
body.fw-selection-locked select,
body.vizlet-header-drawer-dragging input,
body.vizlet-header-drawer-dragging textarea,
body.vizlet-header-drawer-dragging select {
  user-select: text !important;
  -webkit-user-select: text !important;
}

/* Compact formula dialog — size to content */
.vizlet-header-ratio-dialog {
  width: min(400px, calc(100vw - 12px)) !important;
  max-width: min(400px, 92vw) !important;
  height: auto !important;
  min-height: 0 !important;
  max-height: min(88vh, 720px) !important;
}

.vizlet-header-drawer-content {
  min-height: 0;
  border-radius: 0;
  border-left: none;
  box-shadow: 6px 0 28px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.vizlet-header-col-manager-drawer .vizlet-header-drawer-content {
  height: auto !important;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

.vizlet-header-ratio-drawer .vizlet-header-ratio-drawer-content {
  height: auto;
}

.vizlet-header-col-manager-drawer .modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: min(calc(92vh - 5.75rem), 72vh);
  padding: 0.5rem 0.65rem !important;
}

.vizlet-header-col-manager-dialog--resized .modal-body {
  max-height: none;
  overflow: hidden;
}

.vizlet-header-ratio-drawer .modal-body {
  flex: 0 1 auto;
  min-height: 0;
  overflow-y: auto;
  max-height: min(70vh, 560px);
  padding: 0.65rem 0.75rem !important;
}

.vizlet-header-col-manager-drawer .modal-header,
.vizlet-header-ratio-drawer .modal-header {
  flex-shrink: 0;
  border-bottom: 1px solid #dee2e6;
  padding: 0.35rem 0.55rem !important;
  align-items: center !important;
}

.vizlet-drawer-header-row {
  min-height: 0;
}

.vizlet-drawer-title {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
}

.vizlet-drawer-close {
  padding: 0.2rem 0.35rem !important;
  margin: 0 !important;
  font-size: 1.1rem;
  line-height: 1;
  opacity: 0.72;
}

.vizlet-drawer-close:hover {
  opacity: 1;
}

.vizlet-drawer-drag-handle {
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  touch-action: none;
}

.vizlet-drawer-drag-handle:active {
  cursor: grabbing;
}

body.vizlet-header-drawer-dragging,
body.vizlet-header-drawer-dragging .vizlet-drawer-drag-handle {
  cursor: grabbing !important;
}

.vizlet-drawer-grip {
  font-size: 0.85rem;
  opacity: 0.75;
}

.vizlet-drawer-alert {
  user-select: text !important;
  -webkit-user-select: text !important;
  cursor: text;
  white-space: pre-wrap;
  word-break: break-word;
}

.vizlet-fetch-error-query {
  font-size: 0.75rem;
  user-select: text !important;
  -webkit-user-select: text !important;
  cursor: text;
  line-height: 1.35;
  max-height: 12rem;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  background: rgba(0, 0, 0, 0.04);
  padding: 0.5rem 0.65rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.vizlet-error-query-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.vizlet-error-query-copy-btn {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
}

.vizlet-error-query-copy-source {
  position: fixed;
  left: -9999px;
  top: 0;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: 0;
  border: 0;
  opacity: 0;
  overflow: hidden;
  white-space: pre;
  resize: none;
  user-select: text !important;
  -webkit-user-select: text !important;
}

@media (max-width: 576px) {
  .vizlet-header-col-manager-dialog:not(.vizlet-header-col-manager-dialog--resized) {
    width: calc(100vw - 8px) !important;
    max-width: calc(100vw - 8px) !important;
  }
  .vizlet-header-ratio-dialog {
    width: calc(100vw - 8px) !important;
    max-width: calc(100vw - 8px) !important;
  }
}

.vizlet-col-new-icon {
  font-size: 0.72rem;
  font-weight: 900;
  line-height: 1;
  vertical-align: middle;
  color: #0369a1;
  cursor: help;
}

.sc-vh-title-row {
  flex-wrap: nowrap;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
}

.sc-vh-title-row__info {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
</style>
